// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin Test Dashboard Styles */

.admin-test-dashboard {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

/* Password Prompt Styles */
.password-prompt-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.password-prompt-modal {
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  max-width: 450px;
  width: 90%;
  animation: slideIn 0.3s ease;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.password-prompt-header {
  text-align: center;
  margin-bottom: 30px;
}

.password-prompt-header h2 {
  margin: 0 0 10px 0;
  color: #2c3e50;
  font-size: 28px;
}

.password-prompt-header p {
  margin: 0;
  color: #7f8c8d;
  font-size: 16px;
}

.password-prompt-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.password-input-group {
  display: flex;
  flex-direction: column;
}

.password-input {
  padding: 15px;
  font-size: 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  transition: all 0.3s ease;
  font-family: inherit;
  color: #2c3e50;
  background-color: #ffffff;
}

.password-input:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
}

.password-error {
  padding: 12px;
  background-color: #fee;
  border: 1px solid #fcc;
  border-radius: 6px;
  color: #c33;
  font-size: 14px;
  text-align: center;
}

.password-submit-btn {
  padding: 15px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.password-submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.password-submit-btn:active {
  transform: translateY(0);
}

.password-hint {
  text-align: center;
  padding-top: 10px;
  border-top: 1px solid #e0e0e0;
}

.password-hint p {
  margin: 0;
  color: #95a5a6;
  font-size: 13px;
  font-style: italic;
}

.password-dont-know {
  text-align: center;
  margin-top: 16px;
}

.password-dont-know-link {
  background: none;
  border: none;
  color: #218aff;
  font-size: 14px;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
  transition: color 0.2s ease;
}

.password-dont-know-link:hover {
  color: #1a7aef;
}

.password-logout-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  padding: 8px 16px;
  background: #e74c3c;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.password-logout-btn:hover {
  background: #c0392b;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(231, 76, 60, 0.3);
}

.dashboard-header {
  background: white;
  padding: 30px;
  border-radius: 10px;
  margin-bottom: 30px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.dashboard-header h1 {
  margin: 0 0 10px 0;
  color: #2c3e50;
  font-size: 32px;
}

.dashboard-subtitle {
  color: #7f8c8d;
  margin: 0;
  font-size: 16px;
}

/* Tabs */
.dashboard-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 30px;
  background: white;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.tab-btn {
  padding: 12px 24px;
  background: #f8f9fa;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  color: #495057;
  transition: all 0.3s ease;
}

.tab-btn:hover:not(:disabled) {
  background: #e9ecef;
}

.tab-btn.active {
  background: #007bff;
  color: white;
}

.tab-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Error Message */
.error-message {
  background: #f8d7da;
  color: #721c24;
  padding: 15px;
  border-radius: 6px;
  margin-bottom: 20px;
  border: 1px solid #f5c6cb;
}

/* Tab Content */
.tab-content {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

/* Test Runner Styles */
.test-runner {
  max-width: 900px;
}

.runner-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
}

.environment-selector {
  display: flex;
  align-items: center;
  gap: 15px;
}

.environment-selector label {
  font-weight: 600;
  color: #495057;
}

.environment-selector select {
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  font-size: 16px;
}

.env-badge {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.env-badge.development {
  background: #28a745;
  color: white;
}

.env-badge.production {
  background: #dc3545;
  color: white;
}

.selection-controls {
  display: flex;
  gap: 10px;
}

.selection-controls button {
  padding: 8px 16px;
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.3s;
}

.selection-controls button:hover:not(:disabled) {
  background: #5a6268;
}

.selection-controls button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Test Selection */
.test-selection h3 {
  margin-bottom: 20px;
  color: #2c3e50;
}

.test-category {
  margin-bottom: 25px;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  overflow: hidden;
}

.category-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.category-header h4 {
  margin: 0;
  color: #495057;
}

.select-category-btn {
  padding: 6px 12px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.3s;
}

.select-category-btn:hover:not(:disabled) {
  background: #0056b3;
}

.select-category-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.test-list {
  padding: 15px 20px;
}

.test-item {
  display: flex;
  align-items: center;
  padding: 10px 0;
  cursor: pointer;
  transition: background 0.2s;
}

.test-item:hover {
  background: #f8f9fa;
}

.test-item input[type="checkbox"] {
  margin-right: 12px;
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.test-name {
  flex: 1 1;
  color: #495057;
  font-size: 15px;
}

.test-info {
  margin-left: 8px;
  cursor: help;
  font-size: 14px;
  opacity: 0.6;
  transition: opacity 0.2s;
}

.test-info:hover {
  opacity: 1;
}

/* Run Controls */
.run-controls {
  margin-top: 30px;
  padding-top: 30px;
  border-top: 1px solid #e9ecef;
}

.run-button {
  width: 100%;
  padding: 15px 30px;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s;
}

.run-button:hover:not(:disabled) {
  background: #218838;
}

.run-button:disabled {
  background: #6c757d;
  cursor: not-allowed;
}

.warning-message {
  margin-top: 15px;
  padding: 12px;
  background: #fff3cd;
  color: #856404;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  font-size: 14px;
}

/* Test Results Styles */
.test-results {
  max-width: 1000px;
}

.results-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #e9ecef;
}

.results-header h2 {
  margin: 0;
  color: #2c3e50;
}

.run-info {
  display: flex;
  gap: 10px;
}

.environment-badge {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  background: #6c757d;
  color: white;
}

.status-badge {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
}

.status-passed,
.status-completed {
  background: #d4edda;
  color: #155724;
}

.status-failed {
  background: #f8d7da;
  color: #721c24;
}

.status-running {
  background: #fff3cd;
  color: #856404;
}

.status-skipped {
  background: #e7f3ff;
  color: #004085;
}

/* Results Summary */
.results-summary {
  margin-bottom: 30px;
}

.summary-card {
  padding: 25px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #dee2e6;
}

.summary-card h3 {
  margin: 0 0 20px 0;
  color: #495057;
}

.summary-stats,
.timing-info {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
}

.stat {
  display: flex;
  flex-direction: column;
}

.stat label {
  font-size: 14px;
  color: #6c757d;
  margin-bottom: 5px;
}

.stat span {
  font-size: 20px;
  font-weight: 600;
  color: #2c3e50;
}

.passed-count {
  color: #28a745 !important;
}

.failed-count {
  color: #dc3545 !important;
}

.success-rate {
  color: #28a745 !important;
}

.partial-rate {
  color: #ffc107 !important;
}

/* Test Results List */
.results-details h3 {
  margin-bottom: 20px;
  color: #2c3e50;
}

.results-category {
  margin-bottom: 30px;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  overflow: hidden;
}

.results-category .category-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.results-category .category-header h4 {
  margin: 0;
  color: #495057;
  font-size: 16px;
  font-weight: 600;
}

.results-category .category-summary {
  font-size: 14px;
  color: #6c757d;
  font-weight: 500;
}

.test-results-list {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 10px;
}

.test-result-item {
  padding: 15px;
  border: none;
  border-left: 4px solid transparent;
  border-bottom: 1px solid #e9ecef;
  background: white;
  margin: 0;
}

.test-result-item:last-child {
  border-bottom: none;
}

.test-result-item.status-passed {
  border-left: 4px solid #28a745;
}

.test-result-item.status-failed {
  border-left: 4px solid #dc3545;
  background: #fff5f5;
}

.test-result-item.status-running {
  border-left: 4px solid #ffc107;
  background: #fffbf0;
}

.test-result-item.status-skipped {
  border-left: 4px solid #0066cc;
  background: #f0f8ff;
}

.skip-details {
  margin-top: 10px;
  padding: 10px;
  background: #e7f3ff;
  border-radius: 4px;
  font-size: 14px;
  color: #004085;
}

.skipped-count {
  color: #0066cc;
  font-weight: 600;
}

.result-header {
  display: flex;
  align-items: center;
  gap: 15px;
}

.result-icon {
  font-size: 20px;
}

.result-name {
  flex: 1 1;
  font-weight: 600;
  color: #2c3e50;
}

.result-duration {
  color: #6c757d;
  font-size: 14px;
}

.error-details {
  margin-top: 10px;
  padding: 10px;
  background: #f8d7da;
  color: #721c24;
  border-radius: 4px;
  font-size: 14px;
}

.test-details {
  margin-top: 10px;
}

.test-details summary {
  cursor: pointer;
  color: #007bff;
  font-size: 14px;
}

.test-details pre {
  margin-top: 10px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 4px;
  font-size: 12px;
  overflow-x: auto;
}

/* Running Indicator */
.running-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px;
  margin-top: 30px;
  background: #f8f9fa;
  border-radius: 8px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #dee2e6;
  border-top-color: #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.running-indicator p {
  margin-top: 20px;
  color: #6c757d;
}

/* Test History Styles */
.test-history {
  width: 100%;
}

.history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.history-header h2 {
  margin: 0;
  color: #2c3e50;
}

.history-filters {
  display: flex;
  gap: 15px;
}

.filter-select {
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  font-size: 14px;
}

/* History Table */
.history-table {
  overflow-x: auto;
}

.history-table table {
  width: 100%;
  border-collapse: collapse;
}

.history-table th {
  text-align: left;
  padding: 12px;
  background: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  color: #495057;
  font-weight: 600;
}

.history-table td {
  padding: 12px;
  border-bottom: 1px solid #e9ecef;
}

.history-table tr:hover {
  background: #f8f9fa;
}

.no-data {
  text-align: center;
  color: #6c757d;
  padding: 30px !important;
}

.test-counts {
  font-weight: 600;
}

.test-counts .passed {
  color: #28a745;
}

.test-counts .total {
  color: #495057;
}

.success-rate {
  font-weight: 600;
}

.success-rate.perfect {
  color: #28a745;
}

.success-rate.partial {
  color: #ffc107;
}

.success-rate.low {
  color: #dc3545;
}

.date-cell {
  font-size: 14px;
  color: #6c757d;
}

.view-btn {
  padding: 6px 16px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.3s;
}

.view-btn:hover {
  background: #0056b3;
}

/* Error Summary Section */
.error-summary-section {
  margin-bottom: 30px;
}

.error-summary-card {
  padding: 25px;
  background: #fff5f5;
  border-radius: 8px;
  border: 2px solid #f8d7da;
}

.error-summary-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f8d7da;
}

.error-summary-header h3 {
  margin: 0;
  color: #721c24;
  font-size: 20px;
}

.copy-errors-btn {
  padding: 10px 20px;
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.copy-errors-btn:hover {
  background: #c82333;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3);
}

.copy-errors-btn:active {
  transform: translateY(0);
}

.error-summary-content {
  background: white;
  border-radius: 6px;
  padding: 20px;
}

.error-list-compact {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 20px;
}

.error-item-compact {
  padding: 15px;
  background: #fff;
  border: 1px solid #f8d7da;
  border-left: 4px solid #dc3545;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.error-item-compact:hover {
  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.2);
  transform: translateX(4px);
}

.error-test-name {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.error-test-name strong {
  color: #2c3e50;
  font-size: 15px;
}

.error-duration {
  color: #6c757d;
  font-size: 13px;
  font-weight: normal;
}

.error-message-text {
  color: #721c24;
  font-size: 14px;
  line-height: 1.6;
  padding: 10px;
  background: #f8d7da;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  word-break: break-word;
}

.copy-hint {
  text-align: center;
  color: #6c757d;
  font-size: 13px;
  font-style: italic;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px dashed #dee2e6;
}

/* ============================================
   DATA LOADING STYLES
   ============================================ */

.data-loading-container {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.data-loading-container h2 {
  margin: 0 0 10px 0;
  color: #2c3e50;
  font-size: 28px;
}

.data-loading-container .description {
  color: #7f8c8d;
  margin: 0 0 30px 0;
  font-size: 16px;
}

.stats-card, .actions-card {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 25px;
  margin-bottom: 25px;
  border: 1px solid #e9ecef;
}

.stats-card h3, .actions-card h3 {
  margin: 0 0 20px 0;
  color: #495057;
  font-size: 20px;
  border-bottom: 2px solid #dee2e6;
  padding-bottom: 10px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.stat-item.full-width {
  grid-column: 1 / -1;
}

.stat-label {
  font-size: 14px;
  color: #6c757d;
  font-weight: 500;
}

.stat-value {
  font-size: 28px;
  font-weight: 700;
}

.stat-value.success {
  color: #28a745;
}

.stat-value.warning {
  color: #ffc107;
}

.stat-value.error {
  color: #dc3545;
}

.ticker-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.chip {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 13px;
  font-weight: 600;
}

.chip.success {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.chip.error {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.type-breakdown {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-top: 10px;
}

.type-item {
  background: white;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  color: #495057;
  border: 1px solid #dee2e6;
}

.loading-placeholder {
  text-align: center;
  padding: 40px;
  color: #6c757d;
  font-style: italic;
}

.action-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
  padding: 20px;
  background: white;
  border-radius: 8px;
  margin-bottom: 15px;
  border: 1px solid #dee2e6;
}

.action-item.danger-zone {
  border-color: #dc3545;
  background: #fff5f5;
}

.action-info {
  flex: 1 1;
}

.action-info h4 {
  margin: 0 0 10px 0;
  color: #2c3e50;
  font-size: 18px;
}

.action-info p {
  margin: 5px 0;
  color: #6c757d;
  font-size: 14px;
  line-height: 1.5;
}

.action-info .note {
  margin-top: 10px;
  padding: 10px;
  background: #e7f3ff;
  border-left: 3px solid #007bff;
  border-radius: 4px;
  font-size: 13px;
}

.danger-zone .action-info .note {
  background: #ffe6e6;
  border-left-color: #dc3545;
}

.btn-primary, .btn-secondary, .btn-danger {
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.btn-primary {
  background: #007bff;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background: #0056b3;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
}

.btn-secondary {
  background: #6c757d;
  color: white;
}

.btn-secondary:hover:not(:disabled) {
  background: #5a6268;
}

.btn-danger {
  background: #dc3545;
  color: white;
}

.btn-danger:hover:not(:disabled) {
  background: #c82333;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3);
}

.btn-sm {
  padding: 8px 16px;
  font-size: 14px;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.success-message {
  background: #d4edda;
  color: #155724;
  padding: 15px 20px;
  border-radius: 6px;
  border: 1px solid #c3e6cb;
  margin-top: 20px;
  font-size: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.error-message {
  background: #f8d7da;
  color: #721c24;
  padding: 15px 20px;
  border-radius: 6px;
  border: 1px solid #f5c6cb;
  margin-top: 20px;
  font-size: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
}

/* ============================================ */
/* Test Progress Modal Styles */
/* ============================================ */

.test-progress-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.test-progress-modal {
  background: white;
  padding: 40px;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  max-width: 600px;
  width: 90%;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.progress-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #e0e0e0;
}

.progress-header h2 {
  margin: 0;
  color: #2c3e50;
  font-size: 26px;
}

.progress-header .close-btn {
  background: transparent;
  border: none;
  font-size: 32px;
  color: #95a5a6;
  cursor: pointer;
  line-height: 1;
  padding: 0;
  width: 32px;
  height: 32px;
  transition: all 0.2s ease;
}

.progress-header .close-btn:hover {
  color: #e74c3c;
  transform: scale(1.1);
}

.progress-content {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.progress-error {
  padding: 12px;
  background-color: #fee;
  border: 1px solid #fcc;
  border-radius: 8px;
  color: #c33;
  font-size: 14px;
  text-align: center;
}

.progress-counter {
  text-align: center;
}

.progress-text {
  font-size: 20px;
  color: #2c3e50;
  font-weight: 600;
}

.progress-bar-container {
  width: 100%;
  height: 30px;
  background: #e9ecef;
  border-radius: 15px;
  overflow: hidden;
  position: relative;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
}

.progress-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  transition: width 0.5s ease;
  border-radius: 15px;
  position: relative;
  overflow: hidden;
}

.progress-bar-fill::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.3) 50%,
    transparent 100%
  );
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

.progress-percentage {
  text-align: center;
  margin-top: 10px;
  font-size: 18px;
  color: #667eea;
  font-weight: 700;
}

.current-test-info {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 10px;
  border-left: 4px solid #667eea;
}

.current-test-label {
  font-size: 12px;
  text-transform: uppercase;
  color: #95a5a6;
  letter-spacing: 1px;
  margin-bottom: 8px;
  font-weight: 600;
}

.current-test-name {
  font-size: 16px;
  color: #2c3e50;
  font-weight: 600;
}

.progress-summary {
  display: flex;
  justify-content: space-around;
  gap: 20px;
  padding: 20px 0;
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
}

.summary-item {
  text-align: center;
  flex: 1 1;
}

.summary-label {
  display: block;
  font-size: 12px;
  text-transform: uppercase;
  color: #95a5a6;
  margin-bottom: 8px;
  font-weight: 600;
  letter-spacing: 1px;
}

.summary-value {
  display: block;
  font-size: 28px;
  font-weight: 700;
}

.summary-item.passed .summary-value {
  color: #27ae60;
}

.summary-item.failed .summary-value {
  color: #e74c3c;
}

.summary-item.total .summary-value {
  color: #3498db;
}

.completion-message {
  text-align: center;
  padding: 20px;
  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
  border-radius: 10px;
}

.completion-message p {
  margin: 0 0 10px 0;
  font-size: 18px;
  color: #2c3e50;
  font-weight: 600;
}

.auto-close-hint {
  font-size: 14px !important;
  color: #7f8c8d !important;
  font-weight: 400 !important;
}

.status-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
}

.status-indicator span {
  color: #667eea;
  font-size: 14px;
  font-weight: 500;
}

.spinner {
  width: 60px;
  height: 60px;
  border: 6px solid #e9ecef;
  border-top-color: #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

.spinner-small {
  width: 20px;
  height: 20px;
  border: 3px solid #e9ecef;
  border-top-color: #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.progress-actions {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.close-complete-btn {
  padding: 14px 32px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.close-complete-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
}

.close-complete-btn:active {
  transform: translateY(0);
}

/* ============================================
   ROLES MANAGEMENT STYLES
   ============================================ */

.roles-management {
  max-width: 1200px;
}

.roles-intro {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #333;
}

.roles-intro h2 {
  margin: 0 0 10px 0;
  color: #fdfdfd;
  font-size: 28px;
}

.roles-intro p {
  margin: 0;
  color: #aeb9cc;
  font-size: 16px;
}

.roles-section-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 25px;
}

.section-tab {
  padding: 10px 20px;
  background: #2a2a2a;
  border: 2px solid #444;
  border-radius: 6px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  color: #aeb9cc;
  transition: all 0.3s ease;
}

.section-tab:hover {
  background: #333;
}

.section-tab.active {
  background: #218aff;
  border-color: #218aff;
  color: white;
}

.roles-content {
  background: #1a1a1a;
  padding: 25px;
  border-radius: 8px;
  border: 1px solid #333;
}

.roles-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 20px;
  color: #aeb9cc;
}

.roles-loading p {
  margin-top: 20px;
  font-size: 16px;
}

/* User Management Table Styles */
.user-management-table {
  background: #212121;
  border-radius: 8px;
  padding: 20px;
}

.user-management-table .table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 15px;
}

.user-management-table .table-header h3 {
  margin: 0;
  color: #fdfdfd;
  font-size: 22px;
}

.search-box {
  flex: 1 1;
  max-width: 350px;
  min-width: 200px;
}

.search-input {
  width: 100%;
  padding: 10px 15px;
  border: 2px solid #444;
  border-radius: 6px;
  font-size: 15px;
  transition: border-color 0.3s;
  background: #2a2a2a;
  color: #fdfdfd;
}

.search-input::placeholder {
  color: #888;
}

.search-input:focus {
  outline: none;
  border-color: #218aff;
}

.table-container {
  overflow-x: auto;
  margin-bottom: 20px;
}

.users-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 800px;
}

.users-table th {
  text-align: left;
  padding: 14px 12px;
  background: #1f1f1f;
  border-bottom: 2px solid #333;
  color: #aeb9cc;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.users-table td {
  padding: 14px 12px;
  border-bottom: 1px solid #333;
  vertical-align: middle;
  color: #fdfdfd;
}

.users-table tr:hover {
  background: #2a2a2a;
}

.users-table tr.admin-row {
  background: #3d3520;
}

.users-table tr.admin-row:hover {
  background: #4a4028;
}

.username-cell {
  font-weight: 600;
  color: #fdfdfd;
}

.email-cell {
  color: #aeb9cc;
  font-size: 14px;
}

.tier-select {
  padding: 6px 10px;
  border: 1px solid #444;
  border-radius: 4px;
  font-size: 14px;
  background: #2a2a2a;
  color: #fdfdfd;
  cursor: pointer;
  min-width: 120px;
}

.tier-select:focus {
  outline: none;
  border-color: #218aff;
}

.tier-select option {
  background: #2a2a2a;
  color: #fdfdfd;
}

.updating-indicator {
  margin-left: 8px;
  color: #218aff;
  font-weight: bold;
}

.tier-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.tier-free {
  background: #e9ecef;
  color: #495057;
}

.tier-pro {
  background: #cce5ff;
  color: #004085;
}

.tier-enterprise {
  background: #d4edda;
  color: #155724;
}

/* New 4-tier system styles */
.tier-essential {
  background: #d1fae5;
  color: #065f46;
}

.tier-plus {
  background: #dbeafe;
  color: #1e40af;
}

.tier-premium {
  background: #ede9fe;
  color: #5b21b6;
}

.tier-admin {
  background: #f8d7da;
  color: #721c24;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #444;
  transition: 0.3s;
  border-radius: 24px;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
}

.toggle-switch input:checked + .toggle-slider {
  background-color: #28a745;
}

.toggle-switch input:checked + .toggle-slider:before {
  transform: translateX(20px);
}

.toggle-switch input:disabled + .toggle-slider {
  opacity: 0.5;
  cursor: not-allowed;
}

.status-indicator {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

.status-indicator.active {
  background: #d4edda;
  color: #155724;
}

.status-indicator.inactive {
  background: #f8d7da;
  color: #721c24;
}

.date-cell {
  color: #888;
  font-size: 13px;
}

.no-results {
  text-align: center;
  color: #888;
  padding: 40px 20px !important;
  font-style: italic;
}

.table-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 15px;
  border-top: 1px solid #333;
}

.user-count {
  color: #888;
  font-size: 14px;
}

.refresh-btn {
  padding: 8px 16px;
  background: #444;
  color: #fdfdfd;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.3s;
}

.refresh-btn:hover:not(:disabled) {
  background: #555;
}

.refresh-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.dismiss-btn {
  margin-left: 15px;
  padding: 4px 12px;
  background: transparent;
  border: 1px solid #888;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  color: #aeb9cc;
}

.dismiss-btn:hover {
  background: #333;
}

/* Tier Feature Matrix Styles */
.tier-feature-matrix {
  background: #212121;
  border-radius: 8px;
  padding: 20px;
}

.matrix-header {
  margin-bottom: 25px;
}

.matrix-header h3 {
  margin: 0 0 10px 0;
  color: #fdfdfd;
  font-size: 22px;
}

.matrix-subtitle {
  margin: 0;
  color: #aeb9cc;
  font-size: 14px;
}

.matrix-container {
  overflow-x: auto;
  margin-bottom: 20px;
}

.feature-matrix-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 700px;
}

.feature-matrix-table th {
  padding: 16px 12px;
  background: #1f1f1f;
  border-bottom: 2px solid #333;
  font-weight: 600;
  text-align: center;
  color: #aeb9cc;
}

.feature-header {
  text-align: left !important;
  min-width: 250px;
}

.tier-header {
  min-width: 100px;
}

.admin-header {
  background: #3d3520 !important;
}

.tier-name {
  display: inline-block;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
}

.tier-name.tier-free {
  background: #e9ecef;
  color: #495057;
}

.tier-name.tier-pro {
  background: #cce5ff;
  color: #004085;
}

.tier-name.tier-enterprise {
  background: #d4edda;
  color: #155724;
}

/* New 4-tier system styles for TierFeatureMatrix */
.tier-name.tier-essential {
  background: #d1fae5;
  color: #065f46;
}

.tier-name.tier-plus {
  background: #dbeafe;
  color: #1e40af;
}

.tier-name.tier-premium {
  background: #ede9fe;
  color: #5b21b6;
}

.tier-name.tier-admin {
  background: #f8d7da;
  color: #721c24;
}

.feature-matrix-table td {
  padding: 16px 12px;
  border-bottom: 1px solid #333;
  vertical-align: middle;
  color: #fdfdfd;
}

.feature-matrix-table tr:hover {
  background: #2a2a2a;
}

.feature-matrix-table tr.disabled-feature {
  opacity: 0.5;
}

.feature-cell {
  text-align: left;
}

.feature-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.feature-name {
  font-weight: 600;
  color: #fdfdfd;
  font-size: 15px;
}

.feature-code {
  font-size: 12px;
  color: #aeb9cc;
  font-family: monospace;
  background: #333;
  padding: 2px 6px;
  border-radius: 3px;
  display: inline-block;
}

.feature-description {
  font-size: 13px;
  color: #888;
  margin-top: 4px;
}

.feature-disabled-badge {
  display: inline-block;
  margin-top: 8px;
  padding: 4px 10px;
  background: #f8d7da;
  color: #721c24;
  font-size: 11px;
  font-weight: 600;
  border-radius: 4px;
  text-transform: uppercase;
}

.access-cell {
  text-align: center;
}

.admin-access {
  background: #3d3520;
}

.matrix-toggle {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}

.matrix-toggle.updating {
  opacity: 0.5;
}

.matrix-toggle input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.toggle-indicator {
  display: inline-block;
  padding: 6px 14px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  transition: all 0.3s;
}

.toggle-indicator.enabled {
  background: #d4edda;
  color: #155724;
}

.toggle-indicator.disabled {
  background: #f8d7da;
  color: #721c24;
}

.matrix-toggle:hover .toggle-indicator {
  transform: scale(1.05);
}

.always-enabled {
  display: inline-block;
  padding: 6px 14px;
  background: #fff3cd;
  color: #856404;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
}

.matrix-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  border-top: 1px solid #333;
  flex-wrap: wrap;
  gap: 15px;
}

.matrix-legend {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #888;
}

.retry-btn {
  margin-left: 15px;
  padding: 6px 14px;
  background: #218aff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.retry-btn:hover {
  background: #1a7aef;
}

/* ============================================
   Tier Limits Matrix Styles
   ============================================ */

.tier-limits-matrix {
  padding: 20px;
}

.tier-limits-table .limit-cell {
  padding: 12px 8px;
  text-align: center;
}

.limit-input-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.limit-input-wrapper.updating {
  opacity: 0.6;
}

.limit-input {
  width: 100px;
  padding: 8px 12px;
  background: #2a2a2a;
  border: 1px solid #444;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  transition: border-color 0.2s, background-color 0.2s;
}

.limit-input:focus {
  outline: none;
  border-color: #218aff;
  background: #333;
}

.limit-input:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.limit-input::placeholder {
  color: #888;
  font-style: italic;
}

.unlimited-badge {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #065f46;
  color: #d1fae5;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  pointer-events: none;
  white-space: nowrap;
}

.updating-spinner {
  position: absolute;
  right: -24px;
  width: 16px;
  height: 16px;
  border: 2px solid #444;
  border-top-color: #218aff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.tier-limits-table .feature-cell {
  min-width: 200px;
}

.tier-limits-table .feature-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.tier-limits-table .feature-name {
  font-weight: 600;
  color: #fff;
}

.tier-limits-table .feature-description {
  font-size: 12px;
  color: #888;
}

/* ============================================
   REPORTS STYLES
   ============================================ */

.reports-management {
  max-width: 1200px;
}

.reports-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  flex-wrap: wrap;
  gap: 15px;
}

.reports-section-header h3 {
  margin: 0;
  color: #fdfdfd;
  font-size: 22px;
}

.reports-error {
  background: #f8d7da;
  color: #721c24;
  padding: 15px 20px;
  border-radius: 6px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
}

.reports-error p {
  margin: 0;
  flex: 1 1;
}

/* User Summary Styles */
.reports-user-summary {
  padding: 10px;
}

.reports-stat-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.report-stat-card {
  background: #212121;
  border-radius: 10px;
  padding: 20px;
  border: 1px solid #333;
  transition: transform 0.2s, box-shadow 0.2s;
}

.report-stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.stat-card-header {
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #333;
}

.period-label {
  font-size: 14px;
  color: #aeb9cc;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat-card-body {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.stat-main {
  text-align: center;
}

.stat-main .stat-number {
  display: block;
  font-size: 42px;
  font-weight: 700;
  color: #218aff;
  line-height: 1;
}

.stat-main .stat-label {
  display: block;
  font-size: 14px;
  color: #aeb9cc;
  margin-top: 5px;
}

.stat-secondary {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.stat-row {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}

.stat-row .stat-key {
  color: #888;
}

.stat-row .stat-value {
  color: #fdfdfd;
  font-weight: 600;
}

.reports-recent-users {
  background: #212121;
  border-radius: 8px;
  padding: 20px;
  border: 1px solid #333;
}

.reports-recent-users h4 {
  margin: 0 0 20px 0;
  color: #fdfdfd;
  font-size: 18px;
}

/* Tool Usage Styles */
.reports-tool-usage {
  padding: 10px;
}

.period-selector {
  display: flex;
  align-items: center;
  gap: 12px;
}

.period-selector label {
  font-size: 14px;
  color: #aeb9cc;
  font-weight: 500;
}

.period-select {
  padding: 8px 12px;
  border: 2px solid #444;
  border-radius: 6px;
  font-size: 14px;
  background: #2a2a2a;
  color: #fdfdfd;
  cursor: pointer;
}

.period-select:focus {
  outline: none;
  border-color: #218aff;
}

.tool-usage-summary {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
}

.total-activities-card {
  background: linear-gradient(135deg, #218aff 0%, #1a6fcc 100%);
  border-radius: 12px;
  padding: 25px 50px;
  text-align: center;
}

.total-activities-card .total-number {
  display: block;
  font-size: 48px;
  font-weight: 700;
  color: white;
  line-height: 1;
}

.total-activities-card .total-label {
  display: block;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 8px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.tool-bars-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 25px;
}

.tool-bar-item {
  background: #212121;
  border-radius: 8px;
  padding: 15px 20px;
  border: 1px solid #333;
}

.tool-bar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.tool-bar-header .tool-name {
  font-size: 16px;
  font-weight: 600;
  color: #fdfdfd;
}

.tool-bar-header .tool-stats {
  font-size: 14px;
  color: #aeb9cc;
}

.tool-bar-track {
  height: 24px;
  background: #333;
  border-radius: 12px;
  overflow: hidden;
}

.tool-bar-fill {
  height: 100%;
  border-radius: 12px;
  transition: width 0.5s ease;
  min-width: 20px;
}

.tool-legend {
  display: flex;
  justify-content: center;
  gap: 25px;
  flex-wrap: wrap;
  padding: 15px;
  background: #212121;
  border-radius: 8px;
  border: 1px solid #333;
}

.tool-legend .legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tool-legend .legend-color {
  width: 14px;
  height: 14px;
  border-radius: 3px;
}

.tool-legend .legend-label {
  font-size: 14px;
  color: #aeb9cc;
}

/* User Lookup Styles */
.reports-user-lookup {
  padding: 10px;
}

.lookup-form {
  display: flex;
  align-items: flex-end;
  gap: 15px;
  margin-bottom: 30px;
  flex-wrap: wrap;
  background: #212121;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #333;
}

.lookup-input-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1 1;
  min-width: 180px;
}

.lookup-input-group label {
  font-size: 14px;
  color: #aeb9cc;
  font-weight: 500;
}

.lookup-results {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.user-info-card {
  background: #212121;
  border-radius: 8px;
  padding: 20px;
  border: 1px solid #333;
  border-left: 4px solid #218aff;
}

.user-info-card h4 {
  margin: 0 0 8px 0;
  color: #fdfdfd;
  font-size: 20px;
}

.user-info-card .user-email {
  margin: 0;
  color: #aeb9cc;
  font-size: 14px;
}

.lookup-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 15px;
}

.lookup-stat-card {
  background: #212121;
  border-radius: 8px;
  padding: 20px;
  border: 1px solid #333;
  text-align: center;
}

.lookup-stat-card .stat-number {
  display: block;
  font-size: 36px;
  font-weight: 700;
  color: #218aff;
  line-height: 1;
}

.lookup-stat-card .stat-label {
  display: block;
  font-size: 13px;
  color: #aeb9cc;
  margin-top: 8px;
}

.lookup-tool-breakdown {
  background: #212121;
  border-radius: 8px;
  padding: 20px;
  border: 1px solid #333;
}

.lookup-tool-breakdown h4 {
  margin: 0 0 15px 0;
  color: #fdfdfd;
  font-size: 18px;
}

.tool-breakdown-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.tool-breakdown-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #2a2a2a;
  border-radius: 6px;
}

.tool-breakdown-item .tool-indicator {
  width: 12px;
  height: 12px;
  border-radius: 3px;
}

.tool-breakdown-item .tool-name {
  flex: 1 1;
  font-size: 15px;
  color: #fdfdfd;
  font-weight: 500;
}

.tool-breakdown-item .tool-count {
  font-size: 16px;
  font-weight: 700;
  color: #218aff;
}

.tool-breakdown-item .tool-percentage {
  font-size: 14px;
  color: #aeb9cc;
  min-width: 50px;
  text-align: right;
}

.lookup-daily-activity {
  background: #212121;
  border-radius: 8px;
  padding: 20px;
  border: 1px solid #333;
}

.lookup-daily-activity h4 {
  margin: 0 0 15px 0;
  color: #fdfdfd;
  font-size: 18px;
}

.daily-activity-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.daily-activity-item {
  display: flex;
  align-items: center;
  gap: 15px;
}

.daily-activity-item .day-date {
  min-width: 90px;
  font-size: 14px;
  color: #aeb9cc;
}

.daily-activity-item .day-bar-container {
  flex: 1 1;
  height: 20px;
  background: #333;
  border-radius: 10px;
  overflow: hidden;
}

.daily-activity-item .day-bar {
  height: 100%;
  background: linear-gradient(90deg, #218aff 0%, #1a6fcc 100%);
  border-radius: 10px;
  min-width: 4px;
  transition: width 0.3s ease;
}

.daily-activity-item .day-count {
  min-width: 40px;
  text-align: right;
  font-size: 14px;
  font-weight: 600;
  color: #fdfdfd;
}

/* No data message */
.no-data {
  text-align: center;
  color: #888;
  padding: 30px 20px;
  font-style: italic;
}

/* Most Used Tool Card */
.tool-usage-summary {
  display: flex;
  justify-content: center;
  gap: 25px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

.most-used-tool-card {
  background: #212121;
  border-radius: 12px;
  padding: 25px 40px;
  text-align: center;
  border: 2px solid #218aff;
  min-width: 200px;
}

.most-used-tool-card .most-used-label {
  display: block;
  font-size: 12px;
  color: #aeb9cc;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 8px;
}

.most-used-tool-card .most-used-value {
  display: block;
  font-size: 28px;
  font-weight: 700;
  color: #218aff;
  line-height: 1.2;
}

.most-used-tool-card .most-used-stats {
  display: block;
  font-size: 14px;
  color: #aeb9cc;
  margin-top: 8px;
}

/* Top Users by Tool Section */
.top-users-by-tool {
  margin-top: 35px;
}

.top-users-by-tool > h3 {
  margin: 0 0 20px 0;
  color: #fdfdfd;
  font-size: 20px;
}

.top-users-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.top-users-card {
  background: #212121;
  border-radius: 8px;
  border: 1px solid #333;
  overflow: hidden;
}

.top-users-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px 20px;
  background: #1a1a1a;
  border-left: 4px solid #218aff;
}

.top-users-header .tool-icon {
  width: 12px;
  height: 12px;
  border-radius: 3px;
}

.top-users-header h4 {
  margin: 0;
  color: #fdfdfd;
  font-size: 16px;
  font-weight: 600;
}

.top-users-card .no-users {
  padding: 20px;
  text-align: center;
  color: #888;
  font-style: italic;
  margin: 0;
}

.top-users-table {
  width: 100%;
  border-collapse: collapse;
}

.top-users-table thead {
  background: #1a1a1a;
}

.top-users-table th {
  padding: 10px 15px;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  color: #aeb9cc;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #333;
}

.top-users-table th:first-child {
  width: 40px;
  text-align: center;
}

.top-users-table th:last-child {
  width: 80px;
  text-align: right;
}

.top-users-table td {
  padding: 10px 15px;
  border-bottom: 1px solid #2a2a2a;
  font-size: 14px;
}

.top-users-table tbody tr:hover {
  background: #2a2a2a;
}

.top-users-table .rank-cell {
  text-align: center;
  color: #888;
  font-weight: 500;
}

.top-users-table .username-cell {
  color: #fdfdfd;
  font-weight: 500;
}

.top-users-table .count-cell {
  text-align: right;
  color: #218aff;
  font-weight: 600;
}

/* Rank badges for top 3 */
.top-users-table tbody tr:nth-child(1) .rank-cell {
  color: #ffd700;
  font-weight: 700;
}

.top-users-table tbody tr:nth-child(2) .rank-cell {
  color: #c0c0c0;
  font-weight: 700;
}

.top-users-table tbody tr:nth-child(3) .rank-cell {
  color: #cd7f32;
  font-weight: 700;
}

/* ===== Analytics Overview (ReportsOverview) ===== */

.reports-overview {
  padding: 10px;
}

/* KPI Cards Grid */
.analytics-kpi-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 30px;
}

.analytics-kpi-card {
  background: #212121;
  border-radius: 10px;
  padding: 24px;
  border: 1px solid #333;
  border-left: 4px solid #218aff;
  transition: transform 0.2s, box-shadow 0.2s;
}

.analytics-kpi-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.analytics-kpi-card .kpi-label {
  font-size: 13px;
  color: #aeb9cc;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 10px;
}

.analytics-kpi-card .kpi-value {
  font-size: 42px;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 6px;
}

.analytics-kpi-card .kpi-sublabel {
  font-size: 13px;
  color: #888;
}

/* Chart Container */
.analytics-chart-container {
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 10px;
  padding: 24px;
  margin-bottom: 30px;
}

.analytics-chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 15px;
}

.analytics-chart-header h3 {
  margin: 0;
  color: #fdfdfd;
  font-size: 20px;
}

/* Quick Stats Row */
.analytics-quick-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.analytics-quick-stat-card {
  background: #212121;
  border: 1px solid #333;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s;
}

.analytics-quick-stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.analytics-quick-stat-card .quick-stat-label {
  font-size: 13px;
  color: #aeb9cc;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 10px;
}

.analytics-quick-stat-card .quick-stat-value {
  font-size: 36px;
  font-weight: 700;
  color: #fdfdfd;
  line-height: 1;
}

.analytics-quick-stat-card .quick-stat-sublabel {
  font-size: 12px;
  color: #888;
  margin-top: 6px;
}

/* Responsive: KPI cards stack on smaller screens */
@media (max-width: 900px) {
  .analytics-kpi-cards {
    grid-template-columns: repeat(2, 1fr);
  }

  .analytics-quick-stats {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 550px) {
  .analytics-kpi-cards {
    grid-template-columns: 1fr;
  }
}

/* ============================================
   Retention Heatmap Styles
   ============================================ */

.reports-retention {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.analytics-retention-heatmap {
  overflow-x: auto;
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 8px;
  padding: 0;
}

.retention-table {
  width: max-content;
  min-width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.retention-table thead th {
  background: #111;
  color: #aeb9cc;
  font-weight: 600;
  padding: 10px 8px;
  text-align: center;
  border-bottom: 2px solid #333;
  white-space: nowrap;
  position: sticky;
  top: 0;
  z-index: 2;
}

.retention-week-header {
  min-width: 60px;
}

.retention-table tbody tr {
  border-bottom: 1px solid #2a2a2a;
}

.retention-table tbody tr:hover {
  background: rgba(255, 255, 255, 0.03);
}

.retention-table tbody td {
  padding: 8px;
  text-align: center;
  color: #fff;
  font-size: 12px;
  white-space: nowrap;
}

/* Sticky first two columns (Cohort and Users) */
.retention-sticky-col {
  position: sticky;
  z-index: 3;
  background: #1a1a1a;
}

.retention-sticky-cohort {
  left: 0;
  min-width: 80px;
  font-weight: 600;
  color: #fff;
  text-align: left !important;
  padding-left: 14px !important;
  border-right: 1px solid #333;
}

.retention-sticky-users {
  left: 80px;
  min-width: 60px;
  color: #aeb9cc;
  border-right: 1px solid #333;
}

/* Header sticky columns need higher z-index */
.retention-table thead .retention-sticky-col {
  z-index: 4;
  background: #111;
}

/* Heatmap cells */
.retention-cell {
  min-width: 60px;
  transition: opacity 0.15s ease;
  cursor: default;
  font-variant-numeric: tabular-nums;
}

.retention-cell:hover {
  opacity: 0.85;
  outline: 1px solid rgba(255, 255, 255, 0.3);
  outline-offset: -1px;
}

.retention-cell-empty {
  color: #555;
  background-color: transparent !important;
}

/* Responsive: allow smaller heatmap cells on narrow screens */
@media (max-width: 768px) {
  .retention-table {
    font-size: 11px;
  }

  .retention-week-header,
  .retention-cell {
    min-width: 50px;
  }

  .retention-sticky-cohort {
    min-width: 65px;
    padding-left: 8px !important;
  }

  .retention-sticky-users {
    left: 65px;
    min-width: 50px;
  }
}

/* ============================================
   Analytics Dashboard - Additional Styles
   ============================================ */

/* Analytics Tabs (6 tabs overflow handling) */
.analytics-tabs {
  flex-wrap: wrap;
  gap: 6px;
}

.analytics-tabs .section-tab {
  font-size: 13px;
  padding: 8px 14px;
  white-space: nowrap;
}

/* Period Selector & Controls */
.analytics-controls {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.analytics-controls select {
  background: #1a1a1a;
  border: 1px solid #333;
  color: #fff;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
}

.analytics-controls select:focus {
  outline: none;
  border-color: #218aff;
}

/* Filter Toggle Buttons */
.analytics-filter-toggles {
  display: flex;
  gap: 8px;
}

.analytics-filter-btn {
  background: transparent;
  border: 1px solid #333;
  color: #aeb9cc;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.analytics-filter-btn:hover {
  border-color: #218aff;
  color: #fff;
}

.analytics-filter-btn.active {
  background: #218aff;
  border-color: #218aff;
  color: #fff;
}

/* Stickiness Card */
.analytics-stickiness-card {
  background: #212121;
  border: 1px solid #333;
  border-radius: 10px;
  padding: 20px 24px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
}

.stickiness-value {
  font-size: 36px;
  font-weight: 700;
  line-height: 1;
}

.stickiness-label {
  color: #aeb9cc;
  font-size: 14px;
}

.stickiness-sublabel {
  color: #888;
  font-size: 12px;
  margin-top: 4px;
}

/* Summary Stats Grid */
.analytics-summary-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-top: 24px;
}

.analytics-summary-stat {
  background: #212121;
  border: 1px solid #333;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
}

.analytics-summary-stat .stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
}

.analytics-summary-stat .stat-label {
  font-size: 12px;
  color: #aeb9cc;
  margin-top: 6px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.analytics-summary-stat .stat-sublabel {
  font-size: 11px;
  color: #666;
  margin-top: 4px;
}

@media (max-width: 768px) {
  .analytics-summary-stats {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* ===== Conversion Funnel ===== */
.analytics-funnel-container {
  margin-bottom: 30px;
}

.analytics-funnel-stage {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.funnel-bar {
  height: 52px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  transition: all 0.3s ease;
  min-width: 120px;
}

.funnel-bar:hover {
  filter: brightness(1.15);
}

.funnel-bar .funnel-label {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
}

.funnel-bar .funnel-count {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
}

.analytics-funnel-dropoff {
  padding: 6px 0 6px 20px;
  font-size: 13px;
  color: #ef4444;
  display: flex;
  align-items: center;
  gap: 6px;
}

.analytics-funnel-dropoff::before {
  content: '';
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #ef4444;
}

/* Tier Distribution */
.analytics-tier-section {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 30px;
  align-items: start;
}

.analytics-tier-legend {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 20px;
}

.tier-legend-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.tier-legend-dot {
  width: 12px;
  height: 12px;
  border-radius: 3px;
  flex-shrink: 0;
}

.tier-legend-label {
  color: #aeb9cc;
  font-size: 14px;
  flex: 1 1;
}

.tier-legend-count {
  color: #fff;
  font-weight: 600;
  font-size: 14px;
}

@media (max-width: 768px) {
  .analytics-tier-section {
    grid-template-columns: 1fr;
  }
}

/* ===== Session Timeline (User Journey) ===== */
.analytics-user-search {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.analytics-user-search .search-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.analytics-user-search label {
  font-size: 12px;
  color: #aeb9cc;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.analytics-user-search input {
  background: #1a1a1a;
  border: 1px solid #333;
  color: #fff;
  padding: 8px 14px;
  border-radius: 6px;
  font-size: 14px;
  width: 220px;
}

.analytics-user-search input:focus {
  outline: none;
  border-color: #218aff;
}

.analytics-user-profile-card {
  background: #212121;
  border: 1px solid #333;
  border-radius: 10px;
  padding: 20px 24px;
  margin-bottom: 24px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.profile-field {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.profile-field .field-label {
  font-size: 11px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.profile-field .field-value {
  font-size: 15px;
  color: #fff;
  font-weight: 500;
}

.tier-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.analytics-session-timeline {
  margin-bottom: 30px;
}

.analytics-session-block {
  position: relative;
  margin-bottom: 8px;
  background: #212121;
  border: 1px solid #333;
  border-radius: 10px;
  overflow: hidden;
}

.session-header {
  background: #1a1a1a;
  padding: 10px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #333;
}

.session-title {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

.session-meta {
  font-size: 12px;
  color: #888;
}

.session-events {
  padding: 8px 16px;
}

.analytics-event-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px solid #2a2a2a;
}

.analytics-event-item:last-child {
  border-bottom: none;
}

.analytics-event-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 5px;
}

.event-time {
  font-size: 12px;
  color: #888;
  font-family: monospace;
  min-width: 50px;
}

.event-details {
  flex: 1 1;
}

.event-action {
  font-size: 14px;
  color: #fff;
  font-weight: 500;
}

.event-metadata {
  font-size: 12px;
  color: #666;
  margin-top: 2px;
}

.analytics-session-gap {
  text-align: center;
  padding: 6px 0;
  color: #555;
  font-size: 12px;
  font-style: italic;
}

/* ===== Feature Adoption ===== */
.analytics-adoption-bars {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.adoption-bar-item {
  display: grid;
  grid-template-columns: 180px 1fr 80px 80px;
  align-items: center;
  gap: 12px;
  padding: 6px 0;
}

.adoption-bar-label {
  font-size: 13px;
  color: #aeb9cc;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.adoption-bar-track {
  height: 24px;
  background: #2a2a2a;
  border-radius: 4px;
  overflow: hidden;
}

.adoption-bar-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.5s ease;
  min-width: 2px;
}

.adoption-bar-count {
  font-size: 13px;
  color: #fff;
  font-weight: 600;
  text-align: right;
}

.adoption-bar-users {
  font-size: 12px;
  color: #888;
  text-align: right;
}

.analytics-adoption-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.adoption-card {
  background: #212121;
  border: 1px solid #333;
  border-radius: 8px;
  padding: 16px;
}

.adoption-card .adoption-card-action {
  font-size: 13px;
  color: #aeb9cc;
  margin-bottom: 8px;
  font-weight: 600;
}

.adoption-card .adoption-card-value {
  font-size: 28px;
  font-weight: 700;
  color: #fff;
}

.adoption-card .adoption-card-detail {
  font-size: 12px;
  color: #888;
  margin-top: 4px;
}

/* Journey Charts Grid */
.analytics-journey-charts {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-top: 24px;
}

@media (max-width: 900px) {
  .analytics-journey-charts {
    grid-template-columns: 1fr;
  }

  .analytics-user-profile-card {
    grid-template-columns: 1fr;
  }

  .adoption-bar-item {
    grid-template-columns: 140px 1fr 60px 60px;
  }
}

/* No Data State */
.analytics-no-data {
  text-align: center;
  padding: 60px 20px;
  color: #555;
}

.analytics-no-data p {
  font-size: 16px;
  margin-bottom: 8px;
}

.analytics-no-data .no-data-hint {
  font-size: 13px;
  color: #444;
}

/* Recharts Custom Dark Tooltip */
.analytics-tooltip {
  background: #1a1a1a !important;
  border: 1px solid #333 !important;
  border-radius: 8px !important;
  padding: 12px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5) !important;
}

.analytics-tooltip .recharts-tooltip-label {
  color: #aeb9cc !important;
  font-size: 12px !important;
}

.analytics-tooltip .recharts-tooltip-item {
  color: #fff !important;
  font-size: 13px !important;
}

/* ============================================
   User Intelligence Tab
   ============================================ */

.user-intelligence {
  padding: 10px;
}

.user-intelligence-summary {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 14px;
  margin-bottom: 24px;
}

.user-intelligence-summary .summary-card {
  background: #212121;
  border: 1px solid #333;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
  transition: transform 0.15s ease, border-color 0.15s ease;
}

.user-intelligence-summary .summary-card:hover {
  transform: translateY(-2px);
  border-color: #555;
}

.user-intelligence-filters {
  display: flex;
  gap: 20px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  align-items: center;
}

.user-intelligence-filters .filter-group {
  display: flex;
  gap: 6px;
  align-items: center;
}

.user-intelligence-filters .filter-label {
  color: #aeb9cc;
  font-size: 13px;
  font-weight: 600;
  margin-right: 6px;
}

.user-intelligence-table {
  overflow-x: auto;
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 8px;
  margin-bottom: 10px;
}

.user-intelligence-table table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.user-intelligence-table thead th {
  background: #111;
  color: #aeb9cc;
  font-weight: 600;
  padding: 10px 12px;
  text-align: left;
  border-bottom: 2px solid #333;
  white-space: nowrap;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: color 0.15s ease;
}

.user-intelligence-table thead th:hover {
  color: #218aff;
}

.user-intelligence-table tbody tr {
  border-bottom: 1px solid #2a2a2a;
}

.user-intelligence-table tbody tr:hover {
  background: rgba(33, 138, 255, 0.05);
}

.user-intelligence-table tbody td {
  padding: 10px 12px;
  color: #ccc;
  white-space: nowrap;
}

.username-link {
  color: #218aff;
  cursor: pointer;
  text-decoration: none;
  font-weight: 600;
}

.username-link:hover {
  text-decoration: underline;
}

.tier-badge,
.status-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.usage-bar-container {
  display: flex;
  align-items: center;
  gap: 6px;
}

.usage-bar {
  width: 60px;
  height: 6px;
  background: #333;
  border-radius: 3px;
  overflow: hidden;
}

.usage-bar-fill {
  height: 100%;
  border-radius: 3px;
  transition: width 0.3s ease;
}

.hot-leads-section {
  background: #212121;
  border: 1px solid #333;
  border-radius: 10px;
  padding: 24px;
  border-left: 4px solid #f59e0b;
}

.hot-leads-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
}

.hot-lead-card {
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 8px;
  padding: 16px;
  transition: transform 0.15s ease, border-color 0.15s ease;
}

.hot-lead-card:hover {
  transform: translateY(-2px);
  border-color: #f59e0b;
}

@media (max-width: 1200px) {
  .user-intelligence-summary {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 768px) {
  .user-intelligence-summary {
    grid-template-columns: repeat(2, 1fr);
  }

  .user-intelligence-filters {
    flex-direction: column;
    align-items: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AdminTests/AdminTestStyles.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAEhC;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kCAAkC;EAClC,gCAAgC;EAChC,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;EAC5C,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;;iDAEiD;;AAEjD;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,iDAAiD;AACjD,+BAA+B;AAC/B,iDAAiD;;AAEjD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,4DAA4D;EAC5D,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;;GAKC;EACD,8BAA8B;AAChC;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,SAAS;EACT,eAAe;EACf,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;iDAEiD;;AAEjD;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mDAAmD;AACnD;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;;iDAEiD;;AAEjD;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,SAAO;AACT;;AAEA,wBAAwB;AACxB;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,4DAA4D;EAC5D,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,qDAAqD;;AAErD;EACE,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,mDAAmD;AACnD;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;EAChB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;;AAEA,8CAA8C;AAC9C;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,8BAA8B;EAC9B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,wCAAwC;AAC1C;;AAEA,8DAA8D;AAC9D;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;;iDAEiD;;AAEjD,8CAA8C;AAC9C;EACE,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAO;AACT;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0CAA0C;EAC5C;AACF;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,iCAAiC;AACjC;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,6BAA6B;EAC7B,wBAAwB;EACxB,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,yDAAyD;AAC3D;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":["/* Admin Test Dashboard Styles */\n\n.admin-test-dashboard {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 20px;\n  background-color: #f5f7fa;\n  min-height: 100vh;\n}\n\n/* Password Prompt Styles */\n.password-prompt-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.password-prompt-modal {\n  background: white;\n  padding: 40px;\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n  max-width: 450px;\n  width: 90%;\n  animation: slideIn 0.3s ease;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.password-prompt-header {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.password-prompt-header h2 {\n  margin: 0 0 10px 0;\n  color: #2c3e50;\n  font-size: 28px;\n}\n\n.password-prompt-header p {\n  margin: 0;\n  color: #7f8c8d;\n  font-size: 16px;\n}\n\n.password-prompt-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.password-input-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.password-input {\n  padding: 15px;\n  font-size: 16px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  font-family: inherit;\n  color: #2c3e50;\n  background-color: #ffffff;\n}\n\n.password-input:focus {\n  outline: none;\n  border-color: #3498db;\n  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);\n}\n\n.password-error {\n  padding: 12px;\n  background-color: #fee;\n  border: 1px solid #fcc;\n  border-radius: 6px;\n  color: #c33;\n  font-size: 14px;\n  text-align: center;\n}\n\n.password-submit-btn {\n  padding: 15px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.password-submit-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n}\n\n.password-submit-btn:active {\n  transform: translateY(0);\n}\n\n.password-hint {\n  text-align: center;\n  padding-top: 10px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.password-hint p {\n  margin: 0;\n  color: #95a5a6;\n  font-size: 13px;\n  font-style: italic;\n}\n\n.password-dont-know {\n  text-align: center;\n  margin-top: 16px;\n}\n\n.password-dont-know-link {\n  background: none;\n  border: none;\n  color: #218aff;\n  font-size: 14px;\n  cursor: pointer;\n  text-decoration: underline;\n  padding: 0;\n  transition: color 0.2s ease;\n}\n\n.password-dont-know-link:hover {\n  color: #1a7aef;\n}\n\n.password-logout-btn {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  padding: 8px 16px;\n  background: #e74c3c;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.password-logout-btn:hover {\n  background: #c0392b;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(231, 76, 60, 0.3);\n}\n\n.dashboard-header {\n  background: white;\n  padding: 30px;\n  border-radius: 10px;\n  margin-bottom: 30px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.dashboard-header h1 {\n  margin: 0 0 10px 0;\n  color: #2c3e50;\n  font-size: 32px;\n}\n\n.dashboard-subtitle {\n  color: #7f8c8d;\n  margin: 0;\n  font-size: 16px;\n}\n\n/* Tabs */\n.dashboard-tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 30px;\n  background: white;\n  padding: 10px;\n  border-radius: 10px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.tab-btn {\n  padding: 12px 24px;\n  background: #f8f9fa;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n  color: #495057;\n  transition: all 0.3s ease;\n}\n\n.tab-btn:hover:not(:disabled) {\n  background: #e9ecef;\n}\n\n.tab-btn.active {\n  background: #007bff;\n  color: white;\n}\n\n.tab-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Error Message */\n.error-message {\n  background: #f8d7da;\n  color: #721c24;\n  padding: 15px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  border: 1px solid #f5c6cb;\n}\n\n/* Tab Content */\n.tab-content {\n  background: white;\n  padding: 30px;\n  border-radius: 10px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n/* Test Runner Styles */\n.test-runner {\n  max-width: 900px;\n}\n\n.runner-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  padding: 20px;\n  background: #f8f9fa;\n  border-radius: 8px;\n}\n\n.environment-selector {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.environment-selector label {\n  font-weight: 600;\n  color: #495057;\n}\n\n.environment-selector select {\n  padding: 8px 12px;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  font-size: 16px;\n}\n\n.env-badge {\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.env-badge.development {\n  background: #28a745;\n  color: white;\n}\n\n.env-badge.production {\n  background: #dc3545;\n  color: white;\n}\n\n.selection-controls {\n  display: flex;\n  gap: 10px;\n}\n\n.selection-controls button {\n  padding: 8px 16px;\n  background: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background 0.3s;\n}\n\n.selection-controls button:hover:not(:disabled) {\n  background: #5a6268;\n}\n\n.selection-controls button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Test Selection */\n.test-selection h3 {\n  margin-bottom: 20px;\n  color: #2c3e50;\n}\n\n.test-category {\n  margin-bottom: 25px;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.category-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px;\n  background: #f8f9fa;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.category-header h4 {\n  margin: 0;\n  color: #495057;\n}\n\n.select-category-btn {\n  padding: 6px 12px;\n  background: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background 0.3s;\n}\n\n.select-category-btn:hover:not(:disabled) {\n  background: #0056b3;\n}\n\n.select-category-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.test-list {\n  padding: 15px 20px;\n}\n\n.test-item {\n  display: flex;\n  align-items: center;\n  padding: 10px 0;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.test-item:hover {\n  background: #f8f9fa;\n}\n\n.test-item input[type=\"checkbox\"] {\n  margin-right: 12px;\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.test-name {\n  flex: 1;\n  color: #495057;\n  font-size: 15px;\n}\n\n.test-info {\n  margin-left: 8px;\n  cursor: help;\n  font-size: 14px;\n  opacity: 0.6;\n  transition: opacity 0.2s;\n}\n\n.test-info:hover {\n  opacity: 1;\n}\n\n/* Run Controls */\n.run-controls {\n  margin-top: 30px;\n  padding-top: 30px;\n  border-top: 1px solid #e9ecef;\n}\n\n.run-button {\n  width: 100%;\n  padding: 15px 30px;\n  background: #28a745;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 18px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.3s;\n}\n\n.run-button:hover:not(:disabled) {\n  background: #218838;\n}\n\n.run-button:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n}\n\n.warning-message {\n  margin-top: 15px;\n  padding: 12px;\n  background: #fff3cd;\n  color: #856404;\n  border: 1px solid #ffeaa7;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n/* Test Results Styles */\n.test-results {\n  max-width: 1000px;\n}\n\n.results-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.results-header h2 {\n  margin: 0;\n  color: #2c3e50;\n}\n\n.run-info {\n  display: flex;\n  gap: 10px;\n}\n\n.environment-badge {\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n  background: #6c757d;\n  color: white;\n}\n\n.status-badge {\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.status-passed,\n.status-completed {\n  background: #d4edda;\n  color: #155724;\n}\n\n.status-failed {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n.status-running {\n  background: #fff3cd;\n  color: #856404;\n}\n\n.status-skipped {\n  background: #e7f3ff;\n  color: #004085;\n}\n\n/* Results Summary */\n.results-summary {\n  margin-bottom: 30px;\n}\n\n.summary-card {\n  padding: 25px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #dee2e6;\n}\n\n.summary-card h3 {\n  margin: 0 0 20px 0;\n  color: #495057;\n}\n\n.summary-stats,\n.timing-info {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.stat {\n  display: flex;\n  flex-direction: column;\n}\n\n.stat label {\n  font-size: 14px;\n  color: #6c757d;\n  margin-bottom: 5px;\n}\n\n.stat span {\n  font-size: 20px;\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n.passed-count {\n  color: #28a745 !important;\n}\n\n.failed-count {\n  color: #dc3545 !important;\n}\n\n.success-rate {\n  color: #28a745 !important;\n}\n\n.partial-rate {\n  color: #ffc107 !important;\n}\n\n/* Test Results List */\n.results-details h3 {\n  margin-bottom: 20px;\n  color: #2c3e50;\n}\n\n.results-category {\n  margin-bottom: 30px;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.results-category .category-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px;\n  background: #f8f9fa;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.results-category .category-header h4 {\n  margin: 0;\n  color: #495057;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.results-category .category-summary {\n  font-size: 14px;\n  color: #6c757d;\n  font-weight: 500;\n}\n\n.test-results-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  padding: 10px;\n}\n\n.test-result-item {\n  padding: 15px;\n  border: none;\n  border-left: 4px solid transparent;\n  border-bottom: 1px solid #e9ecef;\n  background: white;\n  margin: 0;\n}\n\n.test-result-item:last-child {\n  border-bottom: none;\n}\n\n.test-result-item.status-passed {\n  border-left: 4px solid #28a745;\n}\n\n.test-result-item.status-failed {\n  border-left: 4px solid #dc3545;\n  background: #fff5f5;\n}\n\n.test-result-item.status-running {\n  border-left: 4px solid #ffc107;\n  background: #fffbf0;\n}\n\n.test-result-item.status-skipped {\n  border-left: 4px solid #0066cc;\n  background: #f0f8ff;\n}\n\n.skip-details {\n  margin-top: 10px;\n  padding: 10px;\n  background: #e7f3ff;\n  border-radius: 4px;\n  font-size: 14px;\n  color: #004085;\n}\n\n.skipped-count {\n  color: #0066cc;\n  font-weight: 600;\n}\n\n.result-header {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.result-icon {\n  font-size: 20px;\n}\n\n.result-name {\n  flex: 1;\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n.result-duration {\n  color: #6c757d;\n  font-size: 14px;\n}\n\n.error-details {\n  margin-top: 10px;\n  padding: 10px;\n  background: #f8d7da;\n  color: #721c24;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.test-details {\n  margin-top: 10px;\n}\n\n.test-details summary {\n  cursor: pointer;\n  color: #007bff;\n  font-size: 14px;\n}\n\n.test-details pre {\n  margin-top: 10px;\n  padding: 10px;\n  background: #f8f9fa;\n  border-radius: 4px;\n  font-size: 12px;\n  overflow-x: auto;\n}\n\n/* Running Indicator */\n.running-indicator {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 40px;\n  margin-top: 30px;\n  background: #f8f9fa;\n  border-radius: 8px;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #dee2e6;\n  border-top-color: #007bff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.running-indicator p {\n  margin-top: 20px;\n  color: #6c757d;\n}\n\n/* Test History Styles */\n.test-history {\n  width: 100%;\n}\n\n.history-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n}\n\n.history-header h2 {\n  margin: 0;\n  color: #2c3e50;\n}\n\n.history-filters {\n  display: flex;\n  gap: 15px;\n}\n\n.filter-select {\n  padding: 8px 12px;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n/* History Table */\n.history-table {\n  overflow-x: auto;\n}\n\n.history-table table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.history-table th {\n  text-align: left;\n  padding: 12px;\n  background: #f8f9fa;\n  border-bottom: 2px solid #dee2e6;\n  color: #495057;\n  font-weight: 600;\n}\n\n.history-table td {\n  padding: 12px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.history-table tr:hover {\n  background: #f8f9fa;\n}\n\n.no-data {\n  text-align: center;\n  color: #6c757d;\n  padding: 30px !important;\n}\n\n.test-counts {\n  font-weight: 600;\n}\n\n.test-counts .passed {\n  color: #28a745;\n}\n\n.test-counts .total {\n  color: #495057;\n}\n\n.success-rate {\n  font-weight: 600;\n}\n\n.success-rate.perfect {\n  color: #28a745;\n}\n\n.success-rate.partial {\n  color: #ffc107;\n}\n\n.success-rate.low {\n  color: #dc3545;\n}\n\n.date-cell {\n  font-size: 14px;\n  color: #6c757d;\n}\n\n.view-btn {\n  padding: 6px 16px;\n  background: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background 0.3s;\n}\n\n.view-btn:hover {\n  background: #0056b3;\n}\n\n/* Error Summary Section */\n.error-summary-section {\n  margin-bottom: 30px;\n}\n\n.error-summary-card {\n  padding: 25px;\n  background: #fff5f5;\n  border-radius: 8px;\n  border: 2px solid #f8d7da;\n}\n\n.error-summary-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 15px;\n  border-bottom: 2px solid #f8d7da;\n}\n\n.error-summary-header h3 {\n  margin: 0;\n  color: #721c24;\n  font-size: 20px;\n}\n\n.copy-errors-btn {\n  padding: 10px 20px;\n  background: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.copy-errors-btn:hover {\n  background: #c82333;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3);\n}\n\n.copy-errors-btn:active {\n  transform: translateY(0);\n}\n\n.error-summary-content {\n  background: white;\n  border-radius: 6px;\n  padding: 20px;\n}\n\n.error-list-compact {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  margin-bottom: 20px;\n}\n\n.error-item-compact {\n  padding: 15px;\n  background: #fff;\n  border: 1px solid #f8d7da;\n  border-left: 4px solid #dc3545;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.error-item-compact:hover {\n  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.2);\n  transform: translateX(4px);\n}\n\n.error-test-name {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.error-test-name strong {\n  color: #2c3e50;\n  font-size: 15px;\n}\n\n.error-duration {\n  color: #6c757d;\n  font-size: 13px;\n  font-weight: normal;\n}\n\n.error-message-text {\n  color: #721c24;\n  font-size: 14px;\n  line-height: 1.6;\n  padding: 10px;\n  background: #f8d7da;\n  border-radius: 4px;\n  font-family: 'Courier New', monospace;\n  word-break: break-word;\n}\n\n.copy-hint {\n  text-align: center;\n  color: #6c757d;\n  font-size: 13px;\n  font-style: italic;\n  padding: 15px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border: 1px dashed #dee2e6;\n}\n\n/* ============================================\n   DATA LOADING STYLES\n   ============================================ */\n\n.data-loading-container {\n  background: white;\n  padding: 30px;\n  border-radius: 10px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.data-loading-container h2 {\n  margin: 0 0 10px 0;\n  color: #2c3e50;\n  font-size: 28px;\n}\n\n.data-loading-container .description {\n  color: #7f8c8d;\n  margin: 0 0 30px 0;\n  font-size: 16px;\n}\n\n.stats-card, .actions-card {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 25px;\n  margin-bottom: 25px;\n  border: 1px solid #e9ecef;\n}\n\n.stats-card h3, .actions-card h3 {\n  margin: 0 0 20px 0;\n  color: #495057;\n  font-size: 20px;\n  border-bottom: 2px solid #dee2e6;\n  padding-bottom: 10px;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.stat-item {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.stat-item.full-width {\n  grid-column: 1 / -1;\n}\n\n.stat-label {\n  font-size: 14px;\n  color: #6c757d;\n  font-weight: 500;\n}\n\n.stat-value {\n  font-size: 28px;\n  font-weight: 700;\n}\n\n.stat-value.success {\n  color: #28a745;\n}\n\n.stat-value.warning {\n  color: #ffc107;\n}\n\n.stat-value.error {\n  color: #dc3545;\n}\n\n.ticker-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 12px;\n  border-radius: 16px;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.chip.success {\n  background: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.chip.error {\n  background: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.type-breakdown {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n  margin-top: 10px;\n}\n\n.type-item {\n  background: white;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n  color: #495057;\n  border: 1px solid #dee2e6;\n}\n\n.loading-placeholder {\n  text-align: center;\n  padding: 40px;\n  color: #6c757d;\n  font-style: italic;\n}\n\n.action-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 30px;\n  padding: 20px;\n  background: white;\n  border-radius: 8px;\n  margin-bottom: 15px;\n  border: 1px solid #dee2e6;\n}\n\n.action-item.danger-zone {\n  border-color: #dc3545;\n  background: #fff5f5;\n}\n\n.action-info {\n  flex: 1;\n}\n\n.action-info h4 {\n  margin: 0 0 10px 0;\n  color: #2c3e50;\n  font-size: 18px;\n}\n\n.action-info p {\n  margin: 5px 0;\n  color: #6c757d;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.action-info .note {\n  margin-top: 10px;\n  padding: 10px;\n  background: #e7f3ff;\n  border-left: 3px solid #007bff;\n  border-radius: 4px;\n  font-size: 13px;\n}\n\n.danger-zone .action-info .note {\n  background: #ffe6e6;\n  border-left-color: #dc3545;\n}\n\n.btn-primary, .btn-secondary, .btn-danger {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.btn-primary {\n  background: #007bff;\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: #0056b3;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);\n}\n\n.btn-secondary {\n  background: #6c757d;\n  color: white;\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: #5a6268;\n}\n\n.btn-danger {\n  background: #dc3545;\n  color: white;\n}\n\n.btn-danger:hover:not(:disabled) {\n  background: #c82333;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3);\n}\n\n.btn-sm {\n  padding: 8px 16px;\n  font-size: 14px;\n}\n\nbutton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.success-message {\n  background: #d4edda;\n  color: #155724;\n  padding: 15px 20px;\n  border-radius: 6px;\n  border: 1px solid #c3e6cb;\n  margin-top: 20px;\n  font-size: 15px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.error-message {\n  background: #f8d7da;\n  color: #721c24;\n  padding: 15px 20px;\n  border-radius: 6px;\n  border: 1px solid #f5c6cb;\n  margin-top: 20px;\n  font-size: 15px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n/* ============================================ */\n/* Test Progress Modal Styles */\n/* ============================================ */\n\n.test-progress-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.75);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.test-progress-modal {\n  background: white;\n  padding: 40px;\n  border-radius: 16px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);\n  max-width: 600px;\n  width: 90%;\n  animation: slideUp 0.3s ease;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.progress-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 2px solid #e0e0e0;\n}\n\n.progress-header h2 {\n  margin: 0;\n  color: #2c3e50;\n  font-size: 26px;\n}\n\n.progress-header .close-btn {\n  background: transparent;\n  border: none;\n  font-size: 32px;\n  color: #95a5a6;\n  cursor: pointer;\n  line-height: 1;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  transition: all 0.2s ease;\n}\n\n.progress-header .close-btn:hover {\n  color: #e74c3c;\n  transform: scale(1.1);\n}\n\n.progress-content {\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n}\n\n.progress-error {\n  padding: 12px;\n  background-color: #fee;\n  border: 1px solid #fcc;\n  border-radius: 8px;\n  color: #c33;\n  font-size: 14px;\n  text-align: center;\n}\n\n.progress-counter {\n  text-align: center;\n}\n\n.progress-text {\n  font-size: 20px;\n  color: #2c3e50;\n  font-weight: 600;\n}\n\n.progress-bar-container {\n  width: 100%;\n  height: 30px;\n  background: #e9ecef;\n  border-radius: 15px;\n  overflow: hidden;\n  position: relative;\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.progress-bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);\n  transition: width 0.5s ease;\n  border-radius: 15px;\n  position: relative;\n  overflow: hidden;\n}\n\n.progress-bar-fill::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(\n    90deg,\n    transparent 0%,\n    rgba(255, 255, 255, 0.3) 50%,\n    transparent 100%\n  );\n  animation: shimmer 2s infinite;\n}\n\n@keyframes shimmer {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n.progress-percentage {\n  text-align: center;\n  margin-top: 10px;\n  font-size: 18px;\n  color: #667eea;\n  font-weight: 700;\n}\n\n.current-test-info {\n  background: #f8f9fa;\n  padding: 20px;\n  border-radius: 10px;\n  border-left: 4px solid #667eea;\n}\n\n.current-test-label {\n  font-size: 12px;\n  text-transform: uppercase;\n  color: #95a5a6;\n  letter-spacing: 1px;\n  margin-bottom: 8px;\n  font-weight: 600;\n}\n\n.current-test-name {\n  font-size: 16px;\n  color: #2c3e50;\n  font-weight: 600;\n}\n\n.progress-summary {\n  display: flex;\n  justify-content: space-around;\n  gap: 20px;\n  padding: 20px 0;\n  border-top: 1px solid #e0e0e0;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.summary-item {\n  text-align: center;\n  flex: 1;\n}\n\n.summary-label {\n  display: block;\n  font-size: 12px;\n  text-transform: uppercase;\n  color: #95a5a6;\n  margin-bottom: 8px;\n  font-weight: 600;\n  letter-spacing: 1px;\n}\n\n.summary-value {\n  display: block;\n  font-size: 28px;\n  font-weight: 700;\n}\n\n.summary-item.passed .summary-value {\n  color: #27ae60;\n}\n\n.summary-item.failed .summary-value {\n  color: #e74c3c;\n}\n\n.summary-item.total .summary-value {\n  color: #3498db;\n}\n\n.completion-message {\n  text-align: center;\n  padding: 20px;\n  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);\n  border-radius: 10px;\n}\n\n.completion-message p {\n  margin: 0 0 10px 0;\n  font-size: 18px;\n  color: #2c3e50;\n  font-weight: 600;\n}\n\n.auto-close-hint {\n  font-size: 14px !important;\n  color: #7f8c8d !important;\n  font-weight: 400 !important;\n}\n\n.status-indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 15px;\n  background: #f8f9fa;\n  border-radius: 8px;\n}\n\n.status-indicator span {\n  color: #667eea;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.spinner {\n  width: 60px;\n  height: 60px;\n  border: 6px solid #e9ecef;\n  border-top-color: #667eea;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto;\n}\n\n.spinner-small {\n  width: 20px;\n  height: 20px;\n  border: 3px solid #e9ecef;\n  border-top-color: #667eea;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.progress-actions {\n  margin-top: 20px;\n  display: flex;\n  justify-content: center;\n}\n\n.close-complete-btn {\n  padding: 14px 32px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.close-complete-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);\n}\n\n.close-complete-btn:active {\n  transform: translateY(0);\n}\n\n/* ============================================\n   ROLES MANAGEMENT STYLES\n   ============================================ */\n\n.roles-management {\n  max-width: 1200px;\n}\n\n.roles-intro {\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 2px solid #333;\n}\n\n.roles-intro h2 {\n  margin: 0 0 10px 0;\n  color: #fdfdfd;\n  font-size: 28px;\n}\n\n.roles-intro p {\n  margin: 0;\n  color: #aeb9cc;\n  font-size: 16px;\n}\n\n.roles-section-tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 25px;\n}\n\n.section-tab {\n  padding: 10px 20px;\n  background: #2a2a2a;\n  border: 2px solid #444;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: 600;\n  color: #aeb9cc;\n  transition: all 0.3s ease;\n}\n\n.section-tab:hover {\n  background: #333;\n}\n\n.section-tab.active {\n  background: #218aff;\n  border-color: #218aff;\n  color: white;\n}\n\n.roles-content {\n  background: #1a1a1a;\n  padding: 25px;\n  border-radius: 8px;\n  border: 1px solid #333;\n}\n\n.roles-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 60px 20px;\n  color: #aeb9cc;\n}\n\n.roles-loading p {\n  margin-top: 20px;\n  font-size: 16px;\n}\n\n/* User Management Table Styles */\n.user-management-table {\n  background: #212121;\n  border-radius: 8px;\n  padding: 20px;\n}\n\n.user-management-table .table-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.user-management-table .table-header h3 {\n  margin: 0;\n  color: #fdfdfd;\n  font-size: 22px;\n}\n\n.search-box {\n  flex: 1;\n  max-width: 350px;\n  min-width: 200px;\n}\n\n.search-input {\n  width: 100%;\n  padding: 10px 15px;\n  border: 2px solid #444;\n  border-radius: 6px;\n  font-size: 15px;\n  transition: border-color 0.3s;\n  background: #2a2a2a;\n  color: #fdfdfd;\n}\n\n.search-input::placeholder {\n  color: #888;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #218aff;\n}\n\n.table-container {\n  overflow-x: auto;\n  margin-bottom: 20px;\n}\n\n.users-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 800px;\n}\n\n.users-table th {\n  text-align: left;\n  padding: 14px 12px;\n  background: #1f1f1f;\n  border-bottom: 2px solid #333;\n  color: #aeb9cc;\n  font-weight: 600;\n  font-size: 14px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.users-table td {\n  padding: 14px 12px;\n  border-bottom: 1px solid #333;\n  vertical-align: middle;\n  color: #fdfdfd;\n}\n\n.users-table tr:hover {\n  background: #2a2a2a;\n}\n\n.users-table tr.admin-row {\n  background: #3d3520;\n}\n\n.users-table tr.admin-row:hover {\n  background: #4a4028;\n}\n\n.username-cell {\n  font-weight: 600;\n  color: #fdfdfd;\n}\n\n.email-cell {\n  color: #aeb9cc;\n  font-size: 14px;\n}\n\n.tier-select {\n  padding: 6px 10px;\n  border: 1px solid #444;\n  border-radius: 4px;\n  font-size: 14px;\n  background: #2a2a2a;\n  color: #fdfdfd;\n  cursor: pointer;\n  min-width: 120px;\n}\n\n.tier-select:focus {\n  outline: none;\n  border-color: #218aff;\n}\n\n.tier-select option {\n  background: #2a2a2a;\n  color: #fdfdfd;\n}\n\n.updating-indicator {\n  margin-left: 8px;\n  color: #218aff;\n  font-weight: bold;\n}\n\n.tier-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.tier-free {\n  background: #e9ecef;\n  color: #495057;\n}\n\n.tier-pro {\n  background: #cce5ff;\n  color: #004085;\n}\n\n.tier-enterprise {\n  background: #d4edda;\n  color: #155724;\n}\n\n/* New 4-tier system styles */\n.tier-essential {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.tier-plus {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.tier-premium {\n  background: #ede9fe;\n  color: #5b21b6;\n}\n\n.tier-admin {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 44px;\n  height: 24px;\n}\n\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #444;\n  transition: 0.3s;\n  border-radius: 24px;\n}\n\n.toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.3s;\n  border-radius: 50%;\n}\n\n.toggle-switch input:checked + .toggle-slider {\n  background-color: #28a745;\n}\n\n.toggle-switch input:checked + .toggle-slider:before {\n  transform: translateX(20px);\n}\n\n.toggle-switch input:disabled + .toggle-slider {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.status-indicator {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.status-indicator.active {\n  background: #d4edda;\n  color: #155724;\n}\n\n.status-indicator.inactive {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n.date-cell {\n  color: #888;\n  font-size: 13px;\n}\n\n.no-results {\n  text-align: center;\n  color: #888;\n  padding: 40px 20px !important;\n  font-style: italic;\n}\n\n.table-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 15px;\n  border-top: 1px solid #333;\n}\n\n.user-count {\n  color: #888;\n  font-size: 14px;\n}\n\n.refresh-btn {\n  padding: 8px 16px;\n  background: #444;\n  color: #fdfdfd;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background 0.3s;\n}\n\n.refresh-btn:hover:not(:disabled) {\n  background: #555;\n}\n\n.refresh-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.dismiss-btn {\n  margin-left: 15px;\n  padding: 4px 12px;\n  background: transparent;\n  border: 1px solid #888;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  color: #aeb9cc;\n}\n\n.dismiss-btn:hover {\n  background: #333;\n}\n\n/* Tier Feature Matrix Styles */\n.tier-feature-matrix {\n  background: #212121;\n  border-radius: 8px;\n  padding: 20px;\n}\n\n.matrix-header {\n  margin-bottom: 25px;\n}\n\n.matrix-header h3 {\n  margin: 0 0 10px 0;\n  color: #fdfdfd;\n  font-size: 22px;\n}\n\n.matrix-subtitle {\n  margin: 0;\n  color: #aeb9cc;\n  font-size: 14px;\n}\n\n.matrix-container {\n  overflow-x: auto;\n  margin-bottom: 20px;\n}\n\n.feature-matrix-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 700px;\n}\n\n.feature-matrix-table th {\n  padding: 16px 12px;\n  background: #1f1f1f;\n  border-bottom: 2px solid #333;\n  font-weight: 600;\n  text-align: center;\n  color: #aeb9cc;\n}\n\n.feature-header {\n  text-align: left !important;\n  min-width: 250px;\n}\n\n.tier-header {\n  min-width: 100px;\n}\n\n.admin-header {\n  background: #3d3520 !important;\n}\n\n.tier-name {\n  display: inline-block;\n  padding: 6px 14px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.tier-name.tier-free {\n  background: #e9ecef;\n  color: #495057;\n}\n\n.tier-name.tier-pro {\n  background: #cce5ff;\n  color: #004085;\n}\n\n.tier-name.tier-enterprise {\n  background: #d4edda;\n  color: #155724;\n}\n\n/* New 4-tier system styles for TierFeatureMatrix */\n.tier-name.tier-essential {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.tier-name.tier-plus {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.tier-name.tier-premium {\n  background: #ede9fe;\n  color: #5b21b6;\n}\n\n.tier-name.tier-admin {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n.feature-matrix-table td {\n  padding: 16px 12px;\n  border-bottom: 1px solid #333;\n  vertical-align: middle;\n  color: #fdfdfd;\n}\n\n.feature-matrix-table tr:hover {\n  background: #2a2a2a;\n}\n\n.feature-matrix-table tr.disabled-feature {\n  opacity: 0.5;\n}\n\n.feature-cell {\n  text-align: left;\n}\n\n.feature-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.feature-name {\n  font-weight: 600;\n  color: #fdfdfd;\n  font-size: 15px;\n}\n\n.feature-code {\n  font-size: 12px;\n  color: #aeb9cc;\n  font-family: monospace;\n  background: #333;\n  padding: 2px 6px;\n  border-radius: 3px;\n  display: inline-block;\n}\n\n.feature-description {\n  font-size: 13px;\n  color: #888;\n  margin-top: 4px;\n}\n\n.feature-disabled-badge {\n  display: inline-block;\n  margin-top: 8px;\n  padding: 4px 10px;\n  background: #f8d7da;\n  color: #721c24;\n  font-size: 11px;\n  font-weight: 600;\n  border-radius: 4px;\n  text-transform: uppercase;\n}\n\n.access-cell {\n  text-align: center;\n}\n\n.admin-access {\n  background: #3d3520;\n}\n\n.matrix-toggle {\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.matrix-toggle.updating {\n  opacity: 0.5;\n}\n\n.matrix-toggle input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.toggle-indicator {\n  display: inline-block;\n  padding: 6px 14px;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 600;\n  transition: all 0.3s;\n}\n\n.toggle-indicator.enabled {\n  background: #d4edda;\n  color: #155724;\n}\n\n.toggle-indicator.disabled {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n.matrix-toggle:hover .toggle-indicator {\n  transform: scale(1.05);\n}\n\n.always-enabled {\n  display: inline-block;\n  padding: 6px 14px;\n  background: #fff3cd;\n  color: #856404;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.matrix-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 20px;\n  border-top: 1px solid #333;\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.matrix-legend {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #888;\n}\n\n.retry-btn {\n  margin-left: 15px;\n  padding: 6px 14px;\n  background: #218aff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.retry-btn:hover {\n  background: #1a7aef;\n}\n\n/* ============================================\n   Tier Limits Matrix Styles\n   ============================================ */\n\n.tier-limits-matrix {\n  padding: 20px;\n}\n\n.tier-limits-table .limit-cell {\n  padding: 12px 8px;\n  text-align: center;\n}\n\n.limit-input-wrapper {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.limit-input-wrapper.updating {\n  opacity: 0.6;\n}\n\n.limit-input {\n  width: 100px;\n  padding: 8px 12px;\n  background: #2a2a2a;\n  border: 1px solid #444;\n  border-radius: 4px;\n  color: #fff;\n  font-size: 14px;\n  text-align: center;\n  transition: border-color 0.2s, background-color 0.2s;\n}\n\n.limit-input:focus {\n  outline: none;\n  border-color: #218aff;\n  background: #333;\n}\n\n.limit-input:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.limit-input::placeholder {\n  color: #888;\n  font-style: italic;\n}\n\n.unlimited-badge {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: #065f46;\n  color: #d1fae5;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  pointer-events: none;\n  white-space: nowrap;\n}\n\n.updating-spinner {\n  position: absolute;\n  right: -24px;\n  width: 16px;\n  height: 16px;\n  border: 2px solid #444;\n  border-top-color: #218aff;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.tier-limits-table .feature-cell {\n  min-width: 200px;\n}\n\n.tier-limits-table .feature-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.tier-limits-table .feature-name {\n  font-weight: 600;\n  color: #fff;\n}\n\n.tier-limits-table .feature-description {\n  font-size: 12px;\n  color: #888;\n}\n\n/* ============================================\n   REPORTS STYLES\n   ============================================ */\n\n.reports-management {\n  max-width: 1200px;\n}\n\n.reports-section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 25px;\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.reports-section-header h3 {\n  margin: 0;\n  color: #fdfdfd;\n  font-size: 22px;\n}\n\n.reports-error {\n  background: #f8d7da;\n  color: #721c24;\n  padding: 15px 20px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.reports-error p {\n  margin: 0;\n  flex: 1;\n}\n\n/* User Summary Styles */\n.reports-user-summary {\n  padding: 10px;\n}\n\n.reports-stat-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.report-stat-card {\n  background: #212121;\n  border-radius: 10px;\n  padding: 20px;\n  border: 1px solid #333;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.report-stat-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.stat-card-header {\n  margin-bottom: 15px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #333;\n}\n\n.period-label {\n  font-size: 14px;\n  color: #aeb9cc;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.stat-card-body {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.stat-main {\n  text-align: center;\n}\n\n.stat-main .stat-number {\n  display: block;\n  font-size: 42px;\n  font-weight: 700;\n  color: #218aff;\n  line-height: 1;\n}\n\n.stat-main .stat-label {\n  display: block;\n  font-size: 14px;\n  color: #aeb9cc;\n  margin-top: 5px;\n}\n\n.stat-secondary {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.stat-row {\n  display: flex;\n  justify-content: space-between;\n  font-size: 14px;\n}\n\n.stat-row .stat-key {\n  color: #888;\n}\n\n.stat-row .stat-value {\n  color: #fdfdfd;\n  font-weight: 600;\n}\n\n.reports-recent-users {\n  background: #212121;\n  border-radius: 8px;\n  padding: 20px;\n  border: 1px solid #333;\n}\n\n.reports-recent-users h4 {\n  margin: 0 0 20px 0;\n  color: #fdfdfd;\n  font-size: 18px;\n}\n\n/* Tool Usage Styles */\n.reports-tool-usage {\n  padding: 10px;\n}\n\n.period-selector {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.period-selector label {\n  font-size: 14px;\n  color: #aeb9cc;\n  font-weight: 500;\n}\n\n.period-select {\n  padding: 8px 12px;\n  border: 2px solid #444;\n  border-radius: 6px;\n  font-size: 14px;\n  background: #2a2a2a;\n  color: #fdfdfd;\n  cursor: pointer;\n}\n\n.period-select:focus {\n  outline: none;\n  border-color: #218aff;\n}\n\n.tool-usage-summary {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 30px;\n}\n\n.total-activities-card {\n  background: linear-gradient(135deg, #218aff 0%, #1a6fcc 100%);\n  border-radius: 12px;\n  padding: 25px 50px;\n  text-align: center;\n}\n\n.total-activities-card .total-number {\n  display: block;\n  font-size: 48px;\n  font-weight: 700;\n  color: white;\n  line-height: 1;\n}\n\n.total-activities-card .total-label {\n  display: block;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.8);\n  margin-top: 8px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.tool-bars-container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-bottom: 25px;\n}\n\n.tool-bar-item {\n  background: #212121;\n  border-radius: 8px;\n  padding: 15px 20px;\n  border: 1px solid #333;\n}\n\n.tool-bar-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.tool-bar-header .tool-name {\n  font-size: 16px;\n  font-weight: 600;\n  color: #fdfdfd;\n}\n\n.tool-bar-header .tool-stats {\n  font-size: 14px;\n  color: #aeb9cc;\n}\n\n.tool-bar-track {\n  height: 24px;\n  background: #333;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.tool-bar-fill {\n  height: 100%;\n  border-radius: 12px;\n  transition: width 0.5s ease;\n  min-width: 20px;\n}\n\n.tool-legend {\n  display: flex;\n  justify-content: center;\n  gap: 25px;\n  flex-wrap: wrap;\n  padding: 15px;\n  background: #212121;\n  border-radius: 8px;\n  border: 1px solid #333;\n}\n\n.tool-legend .legend-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.tool-legend .legend-color {\n  width: 14px;\n  height: 14px;\n  border-radius: 3px;\n}\n\n.tool-legend .legend-label {\n  font-size: 14px;\n  color: #aeb9cc;\n}\n\n/* User Lookup Styles */\n.reports-user-lookup {\n  padding: 10px;\n}\n\n.lookup-form {\n  display: flex;\n  align-items: flex-end;\n  gap: 15px;\n  margin-bottom: 30px;\n  flex-wrap: wrap;\n  background: #212121;\n  padding: 20px;\n  border-radius: 8px;\n  border: 1px solid #333;\n}\n\n.lookup-input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex: 1;\n  min-width: 180px;\n}\n\n.lookup-input-group label {\n  font-size: 14px;\n  color: #aeb9cc;\n  font-weight: 500;\n}\n\n.lookup-results {\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n}\n\n.user-info-card {\n  background: #212121;\n  border-radius: 8px;\n  padding: 20px;\n  border: 1px solid #333;\n  border-left: 4px solid #218aff;\n}\n\n.user-info-card h4 {\n  margin: 0 0 8px 0;\n  color: #fdfdfd;\n  font-size: 20px;\n}\n\n.user-info-card .user-email {\n  margin: 0;\n  color: #aeb9cc;\n  font-size: 14px;\n}\n\n.lookup-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 15px;\n}\n\n.lookup-stat-card {\n  background: #212121;\n  border-radius: 8px;\n  padding: 20px;\n  border: 1px solid #333;\n  text-align: center;\n}\n\n.lookup-stat-card .stat-number {\n  display: block;\n  font-size: 36px;\n  font-weight: 700;\n  color: #218aff;\n  line-height: 1;\n}\n\n.lookup-stat-card .stat-label {\n  display: block;\n  font-size: 13px;\n  color: #aeb9cc;\n  margin-top: 8px;\n}\n\n.lookup-tool-breakdown {\n  background: #212121;\n  border-radius: 8px;\n  padding: 20px;\n  border: 1px solid #333;\n}\n\n.lookup-tool-breakdown h4 {\n  margin: 0 0 15px 0;\n  color: #fdfdfd;\n  font-size: 18px;\n}\n\n.tool-breakdown-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.tool-breakdown-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  background: #2a2a2a;\n  border-radius: 6px;\n}\n\n.tool-breakdown-item .tool-indicator {\n  width: 12px;\n  height: 12px;\n  border-radius: 3px;\n}\n\n.tool-breakdown-item .tool-name {\n  flex: 1;\n  font-size: 15px;\n  color: #fdfdfd;\n  font-weight: 500;\n}\n\n.tool-breakdown-item .tool-count {\n  font-size: 16px;\n  font-weight: 700;\n  color: #218aff;\n}\n\n.tool-breakdown-item .tool-percentage {\n  font-size: 14px;\n  color: #aeb9cc;\n  min-width: 50px;\n  text-align: right;\n}\n\n.lookup-daily-activity {\n  background: #212121;\n  border-radius: 8px;\n  padding: 20px;\n  border: 1px solid #333;\n}\n\n.lookup-daily-activity h4 {\n  margin: 0 0 15px 0;\n  color: #fdfdfd;\n  font-size: 18px;\n}\n\n.daily-activity-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.daily-activity-item {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.daily-activity-item .day-date {\n  min-width: 90px;\n  font-size: 14px;\n  color: #aeb9cc;\n}\n\n.daily-activity-item .day-bar-container {\n  flex: 1;\n  height: 20px;\n  background: #333;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.daily-activity-item .day-bar {\n  height: 100%;\n  background: linear-gradient(90deg, #218aff 0%, #1a6fcc 100%);\n  border-radius: 10px;\n  min-width: 4px;\n  transition: width 0.3s ease;\n}\n\n.daily-activity-item .day-count {\n  min-width: 40px;\n  text-align: right;\n  font-size: 14px;\n  font-weight: 600;\n  color: #fdfdfd;\n}\n\n/* No data message */\n.no-data {\n  text-align: center;\n  color: #888;\n  padding: 30px 20px;\n  font-style: italic;\n}\n\n/* Most Used Tool Card */\n.tool-usage-summary {\n  display: flex;\n  justify-content: center;\n  gap: 25px;\n  margin-bottom: 30px;\n  flex-wrap: wrap;\n}\n\n.most-used-tool-card {\n  background: #212121;\n  border-radius: 12px;\n  padding: 25px 40px;\n  text-align: center;\n  border: 2px solid #218aff;\n  min-width: 200px;\n}\n\n.most-used-tool-card .most-used-label {\n  display: block;\n  font-size: 12px;\n  color: #aeb9cc;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-bottom: 8px;\n}\n\n.most-used-tool-card .most-used-value {\n  display: block;\n  font-size: 28px;\n  font-weight: 700;\n  color: #218aff;\n  line-height: 1.2;\n}\n\n.most-used-tool-card .most-used-stats {\n  display: block;\n  font-size: 14px;\n  color: #aeb9cc;\n  margin-top: 8px;\n}\n\n/* Top Users by Tool Section */\n.top-users-by-tool {\n  margin-top: 35px;\n}\n\n.top-users-by-tool > h3 {\n  margin: 0 0 20px 0;\n  color: #fdfdfd;\n  font-size: 20px;\n}\n\n.top-users-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 20px;\n}\n\n.top-users-card {\n  background: #212121;\n  border-radius: 8px;\n  border: 1px solid #333;\n  overflow: hidden;\n}\n\n.top-users-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 15px 20px;\n  background: #1a1a1a;\n  border-left: 4px solid #218aff;\n}\n\n.top-users-header .tool-icon {\n  width: 12px;\n  height: 12px;\n  border-radius: 3px;\n}\n\n.top-users-header h4 {\n  margin: 0;\n  color: #fdfdfd;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.top-users-card .no-users {\n  padding: 20px;\n  text-align: center;\n  color: #888;\n  font-style: italic;\n  margin: 0;\n}\n\n.top-users-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.top-users-table thead {\n  background: #1a1a1a;\n}\n\n.top-users-table th {\n  padding: 10px 15px;\n  text-align: left;\n  font-size: 12px;\n  font-weight: 600;\n  color: #aeb9cc;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 1px solid #333;\n}\n\n.top-users-table th:first-child {\n  width: 40px;\n  text-align: center;\n}\n\n.top-users-table th:last-child {\n  width: 80px;\n  text-align: right;\n}\n\n.top-users-table td {\n  padding: 10px 15px;\n  border-bottom: 1px solid #2a2a2a;\n  font-size: 14px;\n}\n\n.top-users-table tbody tr:hover {\n  background: #2a2a2a;\n}\n\n.top-users-table .rank-cell {\n  text-align: center;\n  color: #888;\n  font-weight: 500;\n}\n\n.top-users-table .username-cell {\n  color: #fdfdfd;\n  font-weight: 500;\n}\n\n.top-users-table .count-cell {\n  text-align: right;\n  color: #218aff;\n  font-weight: 600;\n}\n\n/* Rank badges for top 3 */\n.top-users-table tbody tr:nth-child(1) .rank-cell {\n  color: #ffd700;\n  font-weight: 700;\n}\n\n.top-users-table tbody tr:nth-child(2) .rank-cell {\n  color: #c0c0c0;\n  font-weight: 700;\n}\n\n.top-users-table tbody tr:nth-child(3) .rank-cell {\n  color: #cd7f32;\n  font-weight: 700;\n}\n\n/* ===== Analytics Overview (ReportsOverview) ===== */\n\n.reports-overview {\n  padding: 10px;\n}\n\n/* KPI Cards Grid */\n.analytics-kpi-cards {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.analytics-kpi-card {\n  background: #212121;\n  border-radius: 10px;\n  padding: 24px;\n  border: 1px solid #333;\n  border-left: 4px solid #218aff;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.analytics-kpi-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.analytics-kpi-card .kpi-label {\n  font-size: 13px;\n  color: #aeb9cc;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 10px;\n}\n\n.analytics-kpi-card .kpi-value {\n  font-size: 42px;\n  font-weight: 700;\n  line-height: 1;\n  margin-bottom: 6px;\n}\n\n.analytics-kpi-card .kpi-sublabel {\n  font-size: 13px;\n  color: #888;\n}\n\n/* Chart Container */\n.analytics-chart-container {\n  background: #1a1a1a;\n  border: 1px solid #333;\n  border-radius: 10px;\n  padding: 24px;\n  margin-bottom: 30px;\n}\n\n.analytics-chart-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.analytics-chart-header h3 {\n  margin: 0;\n  color: #fdfdfd;\n  font-size: 20px;\n}\n\n/* Quick Stats Row */\n.analytics-quick-stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n}\n\n.analytics-quick-stat-card {\n  background: #212121;\n  border: 1px solid #333;\n  border-radius: 10px;\n  padding: 20px;\n  text-align: center;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.analytics-quick-stat-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.analytics-quick-stat-card .quick-stat-label {\n  font-size: 13px;\n  color: #aeb9cc;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 10px;\n}\n\n.analytics-quick-stat-card .quick-stat-value {\n  font-size: 36px;\n  font-weight: 700;\n  color: #fdfdfd;\n  line-height: 1;\n}\n\n.analytics-quick-stat-card .quick-stat-sublabel {\n  font-size: 12px;\n  color: #888;\n  margin-top: 6px;\n}\n\n/* Responsive: KPI cards stack on smaller screens */\n@media (max-width: 900px) {\n  .analytics-kpi-cards {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .analytics-quick-stats {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 550px) {\n  .analytics-kpi-cards {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ============================================\n   Retention Heatmap Styles\n   ============================================ */\n\n.reports-retention {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.analytics-retention-heatmap {\n  overflow-x: auto;\n  background: #1a1a1a;\n  border: 1px solid #333;\n  border-radius: 8px;\n  padding: 0;\n}\n\n.retention-table {\n  width: max-content;\n  min-width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.retention-table thead th {\n  background: #111;\n  color: #aeb9cc;\n  font-weight: 600;\n  padding: 10px 8px;\n  text-align: center;\n  border-bottom: 2px solid #333;\n  white-space: nowrap;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n\n.retention-week-header {\n  min-width: 60px;\n}\n\n.retention-table tbody tr {\n  border-bottom: 1px solid #2a2a2a;\n}\n\n.retention-table tbody tr:hover {\n  background: rgba(255, 255, 255, 0.03);\n}\n\n.retention-table tbody td {\n  padding: 8px;\n  text-align: center;\n  color: #fff;\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n/* Sticky first two columns (Cohort and Users) */\n.retention-sticky-col {\n  position: sticky;\n  z-index: 3;\n  background: #1a1a1a;\n}\n\n.retention-sticky-cohort {\n  left: 0;\n  min-width: 80px;\n  font-weight: 600;\n  color: #fff;\n  text-align: left !important;\n  padding-left: 14px !important;\n  border-right: 1px solid #333;\n}\n\n.retention-sticky-users {\n  left: 80px;\n  min-width: 60px;\n  color: #aeb9cc;\n  border-right: 1px solid #333;\n}\n\n/* Header sticky columns need higher z-index */\n.retention-table thead .retention-sticky-col {\n  z-index: 4;\n  background: #111;\n}\n\n/* Heatmap cells */\n.retention-cell {\n  min-width: 60px;\n  transition: opacity 0.15s ease;\n  cursor: default;\n  font-variant-numeric: tabular-nums;\n}\n\n.retention-cell:hover {\n  opacity: 0.85;\n  outline: 1px solid rgba(255, 255, 255, 0.3);\n  outline-offset: -1px;\n}\n\n.retention-cell-empty {\n  color: #555;\n  background-color: transparent !important;\n}\n\n/* Responsive: allow smaller heatmap cells on narrow screens */\n@media (max-width: 768px) {\n  .retention-table {\n    font-size: 11px;\n  }\n\n  .retention-week-header,\n  .retention-cell {\n    min-width: 50px;\n  }\n\n  .retention-sticky-cohort {\n    min-width: 65px;\n    padding-left: 8px !important;\n  }\n\n  .retention-sticky-users {\n    left: 65px;\n    min-width: 50px;\n  }\n}\n\n/* ============================================\n   Analytics Dashboard - Additional Styles\n   ============================================ */\n\n/* Analytics Tabs (6 tabs overflow handling) */\n.analytics-tabs {\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.analytics-tabs .section-tab {\n  font-size: 13px;\n  padding: 8px 14px;\n  white-space: nowrap;\n}\n\n/* Period Selector & Controls */\n.analytics-controls {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.analytics-controls select {\n  background: #1a1a1a;\n  border: 1px solid #333;\n  color: #fff;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.analytics-controls select:focus {\n  outline: none;\n  border-color: #218aff;\n}\n\n/* Filter Toggle Buttons */\n.analytics-filter-toggles {\n  display: flex;\n  gap: 8px;\n}\n\n.analytics-filter-btn {\n  background: transparent;\n  border: 1px solid #333;\n  color: #aeb9cc;\n  padding: 6px 14px;\n  border-radius: 6px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.analytics-filter-btn:hover {\n  border-color: #218aff;\n  color: #fff;\n}\n\n.analytics-filter-btn.active {\n  background: #218aff;\n  border-color: #218aff;\n  color: #fff;\n}\n\n/* Stickiness Card */\n.analytics-stickiness-card {\n  background: #212121;\n  border: 1px solid #333;\n  border-radius: 10px;\n  padding: 20px 24px;\n  margin-bottom: 24px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.stickiness-value {\n  font-size: 36px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.stickiness-label {\n  color: #aeb9cc;\n  font-size: 14px;\n}\n\n.stickiness-sublabel {\n  color: #888;\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n/* Summary Stats Grid */\n.analytics-summary-stats {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  margin-top: 24px;\n}\n\n.analytics-summary-stat {\n  background: #212121;\n  border: 1px solid #333;\n  border-radius: 8px;\n  padding: 16px;\n  text-align: center;\n}\n\n.analytics-summary-stat .stat-value {\n  font-size: 24px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.analytics-summary-stat .stat-label {\n  font-size: 12px;\n  color: #aeb9cc;\n  margin-top: 6px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.analytics-summary-stat .stat-sublabel {\n  font-size: 11px;\n  color: #666;\n  margin-top: 4px;\n}\n\n@media (max-width: 768px) {\n  .analytics-summary-stats {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n/* ===== Conversion Funnel ===== */\n.analytics-funnel-container {\n  margin-bottom: 30px;\n}\n\n.analytics-funnel-stage {\n  display: flex;\n  align-items: center;\n  margin-bottom: 4px;\n}\n\n.funnel-bar {\n  height: 52px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 20px;\n  transition: all 0.3s ease;\n  min-width: 120px;\n}\n\n.funnel-bar:hover {\n  filter: brightness(1.15);\n}\n\n.funnel-bar .funnel-label {\n  font-size: 15px;\n  font-weight: 600;\n  color: #fff;\n}\n\n.funnel-bar .funnel-count {\n  font-size: 15px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.analytics-funnel-dropoff {\n  padding: 6px 0 6px 20px;\n  font-size: 13px;\n  color: #ef4444;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.analytics-funnel-dropoff::before {\n  content: '';\n  display: inline-block;\n  width: 0;\n  height: 0;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-top: 6px solid #ef4444;\n}\n\n/* Tier Distribution */\n.analytics-tier-section {\n  display: grid;\n  grid-template-columns: 300px 1fr;\n  gap: 30px;\n  align-items: start;\n}\n\n.analytics-tier-legend {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding-top: 20px;\n}\n\n.tier-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.tier-legend-dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 3px;\n  flex-shrink: 0;\n}\n\n.tier-legend-label {\n  color: #aeb9cc;\n  font-size: 14px;\n  flex: 1;\n}\n\n.tier-legend-count {\n  color: #fff;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n@media (max-width: 768px) {\n  .analytics-tier-section {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ===== Session Timeline (User Journey) ===== */\n.analytics-user-search {\n  display: flex;\n  align-items: flex-end;\n  gap: 12px;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n}\n\n.analytics-user-search .search-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.analytics-user-search label {\n  font-size: 12px;\n  color: #aeb9cc;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.analytics-user-search input {\n  background: #1a1a1a;\n  border: 1px solid #333;\n  color: #fff;\n  padding: 8px 14px;\n  border-radius: 6px;\n  font-size: 14px;\n  width: 220px;\n}\n\n.analytics-user-search input:focus {\n  outline: none;\n  border-color: #218aff;\n}\n\n.analytics-user-profile-card {\n  background: #212121;\n  border: 1px solid #333;\n  border-radius: 10px;\n  padding: 20px 24px;\n  margin-bottom: 24px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.profile-field {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.profile-field .field-label {\n  font-size: 11px;\n  color: #888;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.profile-field .field-value {\n  font-size: 15px;\n  color: #fff;\n  font-weight: 500;\n}\n\n.tier-badge {\n  display: inline-block;\n  padding: 2px 10px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.analytics-session-timeline {\n  margin-bottom: 30px;\n}\n\n.analytics-session-block {\n  position: relative;\n  margin-bottom: 8px;\n  background: #212121;\n  border: 1px solid #333;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.session-header {\n  background: #1a1a1a;\n  padding: 10px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #333;\n}\n\n.session-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #fff;\n}\n\n.session-meta {\n  font-size: 12px;\n  color: #888;\n}\n\n.session-events {\n  padding: 8px 16px;\n}\n\n.analytics-event-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 8px 0;\n  border-bottom: 1px solid #2a2a2a;\n}\n\n.analytics-event-item:last-child {\n  border-bottom: none;\n}\n\n.analytics-event-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  margin-top: 5px;\n}\n\n.event-time {\n  font-size: 12px;\n  color: #888;\n  font-family: monospace;\n  min-width: 50px;\n}\n\n.event-details {\n  flex: 1;\n}\n\n.event-action {\n  font-size: 14px;\n  color: #fff;\n  font-weight: 500;\n}\n\n.event-metadata {\n  font-size: 12px;\n  color: #666;\n  margin-top: 2px;\n}\n\n.analytics-session-gap {\n  text-align: center;\n  padding: 6px 0;\n  color: #555;\n  font-size: 12px;\n  font-style: italic;\n}\n\n/* ===== Feature Adoption ===== */\n.analytics-adoption-bars {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.adoption-bar-item {\n  display: grid;\n  grid-template-columns: 180px 1fr 80px 80px;\n  align-items: center;\n  gap: 12px;\n  padding: 6px 0;\n}\n\n.adoption-bar-label {\n  font-size: 13px;\n  color: #aeb9cc;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.adoption-bar-track {\n  height: 24px;\n  background: #2a2a2a;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.adoption-bar-fill {\n  height: 100%;\n  border-radius: 4px;\n  transition: width 0.5s ease;\n  min-width: 2px;\n}\n\n.adoption-bar-count {\n  font-size: 13px;\n  color: #fff;\n  font-weight: 600;\n  text-align: right;\n}\n\n.adoption-bar-users {\n  font-size: 12px;\n  color: #888;\n  text-align: right;\n}\n\n.analytics-adoption-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.adoption-card {\n  background: #212121;\n  border: 1px solid #333;\n  border-radius: 8px;\n  padding: 16px;\n}\n\n.adoption-card .adoption-card-action {\n  font-size: 13px;\n  color: #aeb9cc;\n  margin-bottom: 8px;\n  font-weight: 600;\n}\n\n.adoption-card .adoption-card-value {\n  font-size: 28px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.adoption-card .adoption-card-detail {\n  font-size: 12px;\n  color: #888;\n  margin-top: 4px;\n}\n\n/* Journey Charts Grid */\n.analytics-journey-charts {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n  margin-top: 24px;\n}\n\n@media (max-width: 900px) {\n  .analytics-journey-charts {\n    grid-template-columns: 1fr;\n  }\n\n  .analytics-user-profile-card {\n    grid-template-columns: 1fr;\n  }\n\n  .adoption-bar-item {\n    grid-template-columns: 140px 1fr 60px 60px;\n  }\n}\n\n/* No Data State */\n.analytics-no-data {\n  text-align: center;\n  padding: 60px 20px;\n  color: #555;\n}\n\n.analytics-no-data p {\n  font-size: 16px;\n  margin-bottom: 8px;\n}\n\n.analytics-no-data .no-data-hint {\n  font-size: 13px;\n  color: #444;\n}\n\n/* Recharts Custom Dark Tooltip */\n.analytics-tooltip {\n  background: #1a1a1a !important;\n  border: 1px solid #333 !important;\n  border-radius: 8px !important;\n  padding: 12px !important;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5) !important;\n}\n\n.analytics-tooltip .recharts-tooltip-label {\n  color: #aeb9cc !important;\n  font-size: 12px !important;\n}\n\n.analytics-tooltip .recharts-tooltip-item {\n  color: #fff !important;\n  font-size: 13px !important;\n}\n\n/* ============================================\n   User Intelligence Tab\n   ============================================ */\n\n.user-intelligence {\n  padding: 10px;\n}\n\n.user-intelligence-summary {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 14px;\n  margin-bottom: 24px;\n}\n\n.user-intelligence-summary .summary-card {\n  background: #212121;\n  border: 1px solid #333;\n  border-radius: 8px;\n  padding: 16px;\n  text-align: center;\n  transition: transform 0.15s ease, border-color 0.15s ease;\n}\n\n.user-intelligence-summary .summary-card:hover {\n  transform: translateY(-2px);\n  border-color: #555;\n}\n\n.user-intelligence-filters {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.user-intelligence-filters .filter-group {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.user-intelligence-filters .filter-label {\n  color: #aeb9cc;\n  font-size: 13px;\n  font-weight: 600;\n  margin-right: 6px;\n}\n\n.user-intelligence-table {\n  overflow-x: auto;\n  background: #1a1a1a;\n  border: 1px solid #333;\n  border-radius: 8px;\n  margin-bottom: 10px;\n}\n\n.user-intelligence-table table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.user-intelligence-table thead th {\n  background: #111;\n  color: #aeb9cc;\n  font-weight: 600;\n  padding: 10px 12px;\n  text-align: left;\n  border-bottom: 2px solid #333;\n  white-space: nowrap;\n  cursor: pointer;\n  user-select: none;\n  transition: color 0.15s ease;\n}\n\n.user-intelligence-table thead th:hover {\n  color: #218aff;\n}\n\n.user-intelligence-table tbody tr {\n  border-bottom: 1px solid #2a2a2a;\n}\n\n.user-intelligence-table tbody tr:hover {\n  background: rgba(33, 138, 255, 0.05);\n}\n\n.user-intelligence-table tbody td {\n  padding: 10px 12px;\n  color: #ccc;\n  white-space: nowrap;\n}\n\n.username-link {\n  color: #218aff;\n  cursor: pointer;\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.username-link:hover {\n  text-decoration: underline;\n}\n\n.tier-badge,\n.status-badge {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.usage-bar-container {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.usage-bar {\n  width: 60px;\n  height: 6px;\n  background: #333;\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.usage-bar-fill {\n  height: 100%;\n  border-radius: 3px;\n  transition: width 0.3s ease;\n}\n\n.hot-leads-section {\n  background: #212121;\n  border: 1px solid #333;\n  border-radius: 10px;\n  padding: 24px;\n  border-left: 4px solid #f59e0b;\n}\n\n.hot-leads-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 16px;\n}\n\n.hot-lead-card {\n  background: #1a1a1a;\n  border: 1px solid #333;\n  border-radius: 8px;\n  padding: 16px;\n  transition: transform 0.15s ease, border-color 0.15s ease;\n}\n\n.hot-lead-card:hover {\n  transform: translateY(-2px);\n  border-color: #f59e0b;\n}\n\n@media (max-width: 1200px) {\n  .user-intelligence-summary {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .user-intelligence-summary {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .user-intelligence-filters {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
